const LOOKUP = {
  authentication: {
    rolesLevels: {
      level1: 'Administrator,StoreOwner,StoreManager,InventoryManager,AssistantManager,SalesLead,SalesPerson,User,SecurityOrCleaning',
      level2: 'Administrator,StoreOwner,StoreManager,InventoryManager,AssistantManager,SalesLead,SalesPerson',
      level2_5: 'Administrator,StoreOwner,StoreManager,InventoryManager,AssistantManager,SalesLead',
      level3: 'Administrator,StoreOwner,StoreManager,InventoryManager,AssistantManager',
      level4: 'Administrator,StoreOwner,StoreManager,InventoryManager',
      level5: 'Administrator,StoreOwner,StoreManager',
      level6: 'Administrator,StoreOwner',
      level7: 'Administrator'
    },
    unauthorizedMessage: "You are not authorized to access this resource, please contact the administrator if this is a unexpected behaviour.",
    changePasswordSuccessMessage: "Your password was changed successfully.",
    changePasswordErrorMessage: "Your password was not changed. Check if the old password is correct or if the new password is valid.",
    resetPasswordSuccessMessage: "Employee's password has been reseted.",
    resetPasswordErrorMessage: "An error occurred while trying to reset employee's password, please try again later. If the error persists, please contact the store administrator.",
    changeEmployeePasswordSuccessMessage: "Employee's password has been changed.",
    changeEmployeePasswordErrorMessage: "An error occurred while trying to change employee's password, please try again later. If the error persists, please contact the store administrator.",
    forgotPasswordSuccessMessage: "A new password has beend sent to your e-mail.",
    forgotPasswordErrorMessage: "Please check your username again.",
    forgotPasswordNullUsername: "Please fill the username to receive the new password.",
    loginNullField: "Please fill the fields."
  },
  store: {
    tableColumns: [
      { key: "Name", label: "Name" },
      { key: "WebSite", label: "Web Site" },
      { key: "CompanyCode", label: "Company Code" }
    ]
  },
  store: {
    tableColumns: [
      { key: "Name", label: "Name", width: "30%" },
      { key: "WebSite", label: "WebSite" },
      { key: "CompanyCode", label: "CompanyCode", width: "30%" }
    ]
  },
  unitOfMeasurement: [
    { text: 'Grams', value: 1 },
    { text: 'Unit', value: 2 }
  ],
  intSpecies: [
    { text: 'Indica', value: 1 },
    { text: 'Hybrid', value: 2 },
    { text: 'Sativa', value: 3 },
    { text: 'CBD', value: 4 },
    { text: 'Blend', value: 5 },
    { text: 'Others', value: 6 },
    { text: "Salted", value: 7 },
    { text: "Ice", value: 8 },
    { text: "Freebase", value: 9 },
    { text: "Pods", value: 10 },
    { text: "Disposables", value: 11 }
  ],
  species: [
    { text: 'Indica', value: "1" },
    { text: 'Hybrid', value: "2" },
    { text: 'Sativa', value: "3" },
    { text: 'CBD', value: "4" },
    { text: 'Blend', value: "5" },
    { text: 'Others', value: "6" },
    { text: "Salted", value: "7" },
    { text: "Ice", value: "8" },
    { text: "Freebase", value: "9" },
    { text: "Pods", value: "10" },
    { text: "Disposables", value: "11" }
  ],
  speciesWithAll: [
    { text: 'All', value: "0" },
    { text: 'Indica', value: "1" },
    { text: 'Hybrid', value: "2" },
    { text: 'Sativa', value: "3" },
    { text: 'CBD', value: "4" },
    { text: 'Blend', value: "5" },
    { text: 'Others', value: "6" }
  ],

  menuData: [
    { text: "Business Insights", link: "/", icon: "", authorize: "level1", pageId: 0 },
    {
      text: "POS Sales", link: "/pos", icon: "", authorize: "level2", component: "POSPage", pageId: 1
    },
    {
      text: "Inventory", link: "", icon: "", authorize: "level2_5", items: [
        { text: "Products", link: "/product", icon: "", authorize: "level3", component: "ProductListPage", pageId: 2 },
        { text: "Categories", link: "/product/category", icon: "", authorize: "level4", component: "ProductCategoryPage", pageId: 3 },
        { text: "Purchase Orders", link: "/purchaseorder", icon: "", authorize: "level2_5", component: "PurchaseOrderPage", pageId: 4 },
        { text: "Warehouse", link: "/transferproduct", icon: "", authorize: "level4", component: "TransferPage", pageId: 5 },
        { text: "Bulk Transfer", link: "/bulktransferproduct", icon: "", authorize: "level2_5", component: "BulkTransfer", pageId: 6 },
        { text: "Product Hub", link: "/producthub", icon: "", authorize: "level2_5", component: "InventoryAdjust", pageId: 7 },
        { text: "Inventory Audit", link: "/inventoryAudit", icon: "", authorize: "level2_5", component: "InventoryAuditList", pageId: 8 },
        { text: "Multi Store Management", link: "/multistoremanagement", icon: "", authorize: "level2_5", component: "MultiStoreManagement", pageId: 9 }
      ]
    },
    {
      text: "Vendor", link: "", icon: "", authorize: "level2_5", items: [
        { text: "Vendor List", link: "/vendor", icon: "", authorize: "level4", component: "VendorPage", pageId: 10 },
        { text: "Accessory Vendor Catalog", link: "/vendorcatalog", icon: "", authorize: "level2", component: "VendorCatalog", pageId: 11 }
      ]
    },
    {
      text: "Users", link: "", icon: "", authorize: "level3", items: [
        { text: "Member", link: "/member", icon: "", authorize: "level3", component: "PatientListPage", pageId: 12 },
        { text: "Employee", link: "/employee", icon: "", authorize: "level5", component: "EmployeeList", pageId: 13 },
        { text: "Doctor", link: "/doctor", icon: "", authorize: "level4", component: "DoctorPage", pageId: 14 },
        { text: "User Role", link: "/userrole", icon: "", authorize: "level6", component: "UserRoleList", pageId: 15 }
      ]
    },
    {
      text: "Admin", link: "", icon: "", authorize: "level3", items: [
        { text: "Cash Register", link: "/admin/cashregister", icon: "", authorize: "level3", component: "CashRegisterPage", pageId: 16 },
        { text: "Bank Deposits", link: "/admin/bankdeposits", icon: "", authorize: "level3", component: "BankDepositPage", pageId: 40 },
        { text: "Safe Management", link: "/admin/safemanagement", icon: "", authorize: "level3", component: "SafeManagementPage", pageId: 42 },
        { text: "Shifts", link: "/admin/shift/list", icon: "", authorize: "level3", component: "ShiftListPage", pageId: 17 },
        { text: "Schedules", link: "/admin/schedule", icon: "", authorize: "level3", component: "SchedulePage", pageId: 18 },
        { text: "Orders", link: "/admin/orders", icon: "", authorize: "level3", component: "OrderListPage", pageId: 19 },
        { text: "Marketing", link: "/admin/marketing", icon: "", authorize: "level3", component: "CommunicatingPage", pageId: 20 },
        { text: "Settings", link: "/admin/setting", icon: "", authorize: "level3", component: "SettingPage", pageId: 21 }
      ]
    },

    {
      text: "Reports", link: "/report", icon: "", authorize: "level2", component: "ReportPage", pageId: 22
    },

    {
      text: "Pricing", link: "", icon: "", authorize: "level4", items: [
        { text: "Measurement Setting", link: "/manage/measurement", icon: "", authorize: "level4", component: "MeasurementPage", pageId: 23 },
        { text: "Price Matrix Setting", link: "/pricematrix", icon: "", authorize: "level4", component: "PriceMatrixPage", pageId: 24 },
        { text: "Tax Setting", link: "/manage/taxrate", icon: "", authorize: "level4", component: "TaxRatePage", pageId: 25 },
        { text: "Campaign", link: "/manage/campaign", icon: "", authorize: "level4", component: "CampaignPage", pageId: 26 },
        { text: "Combo", link: "/manage/combo", icon: "", authorize: "level4", component: "ComboPage", pageId: 27 },
        { text: "Customized Discount", link: "/manage/discount", icon: "", authorize: "level4", component: "DiscountPage", pageId: 28 },
        { text: "Bulk Price Update", link: "/manage/priceupdate", icon: "", authorize: "level4", component: "PriceUpdatePage", pageId: 41 }
      ]
    },
    {
      text: "Preferences", link: "", icon: "", authorize: "level2", items: [
        { text: "Device", link: "/manage/device", icon: "", authorize: "level2", component: "DevicePage", pageId: 29 },
        { text: "Payment", link: "/manage/payment", icon: "", authorize: "level5", component: "PaymentPage", pageId: 30 }
      ]
    },

    {
      text: "Web Menu", link: "", icon: "", authorize: "level1", items: [
        { text: "Online Orders List", link: "/ecommerce/online-orders", icon: "", authorize: "level1", component: "OnlineOrdersPage", pageId: 31 },
        { text: "Store Rules List", link: "/ecommerce/storerules", icon: "", authorize: "level3", component: "StoreRulesPage", pageId: 32 },
        { text: "Menu (Categories) List", link: "/ecommerce/menu", icon: "", authorize: "level3", component: "ProductGroupPage", pageId: 33 },
        { text: "Carousel List", link: "/ecommerce/carousel", icon: "", authorize: "level3", component: "CarouselPage", pageId: 34 },
        { text: "Carousel Order Setting", link: "/ecommerce/homesetting", icon: "", authorize: "level3", component: "HomeSettingPage", pageId: 35 },
        { text: "UI Setting", link: "/ecommerce/uisetting", icon: "", authorize: "level3", component: "UISettingPage", pageId: 36 },
        { text: "SEO Setting", link: "/ecommerce/seosettings", icon: "", authorize: "level3", component: "SEOSettingPage", pageId: 46 },
        { text: "Banner List", link: "/ecommerce/bannerList", icon: "", authorize: "level3", component: "BannerListPage", pageId: 47 }
      ]
    },
    {
      text: "Integration Overview", link: "/integration", icon: "", authorize: "level3", component: "IntegrationOverview", pageId: 39
    },

    {
      text: "Video Support", link: "/video-support", icon: "", authorize: "level2", component: "VideoSupportPage", pageId: 37
    },
    {
      text: "Support Hub", link: "", icon: "", authorize: "level1", items: [
        { text: "New Features", link: "/newfeatures", authorize: "level1", component: "NewFeatures", pageId: 38 },
        { text: "Knowledgebase", link: "https://knowledge.techpos.ca/en/knowledge?_ga=2.241388866.1502978382.1632769906-449988896.1564685719", icon: "", authorize: "level1" },
        { text: "Ticket Portal", link: "https://knowledge.techpos.ca/portal", icon: "", authorize: "level1" },
        { text: "Contact us", link: "https://techpos.ca/contact-us/", icon: "", authorize: "level1" }
      ]
    }

  ],
  menuGov: [
    {
      text: "Compliance Report", link: "/compliances", icon: "", authorize: "level5"
    }
  ],
  menu: {
    home: { text: "Business Insights", link: "/", icon: "" },
    product: { text: "Product List", link: "/product", icon: "" },
    inventoryaudit: { text: "Inventory Audit List", link: "/inventoryaudit", icon: "" },
    productCategory: { text: "Categories", link: "/product/category", icon: "" },
    inventory: {
      text: "Inventory", link: "#", icon: "", items: {
        purchaseOrder: { text: "Purchase Order", link: "/purchaseorder", icon: "" },
        priceMatrix: { text: "Price Setting", link: "/pricematrix", icon: "" },
        vendor: { text: "Vendor", link: "/vendor", icon: "" },
        vendorCatelog: { text: "Accessory Vendor Catalog", link: "/vendorcatalog", icon: "" },
        transferProduct: { text: "Warehouse", link: "/transferproduct", icon: "" },
        bulkTransferProduct: { text: "Bulk Transfer", link: "/bulktransferproduct", icon: "" },
        bulkTransferProductDetails: { text: "Bulk Transfer Details", link: "/bulktransferproduct/add", icon: "" },
        multiStoreManagement: { text: "MultiStore", link: "/multistoremanagement", icon: "" },
      }
    },
    user: {
      text: "Users", link: "#", icon: "",
      items: {
        patient: { text: "Member", link: "/member", icon: "" },
        doctor: { text: "Doctor", link: "/doctor", icon: "" },
        vendor: { text: "Vendor", link: "/vendor", icon: "" },
        employee: { text: "Employee", link: "/employee", icon: "" },
        userRole: { text: "User Roles", link: "/userrole", icon: "" }
      }
    },
    manage: {
      text: "Preferences", link: "#", icon: "",
      items: {
        weight: { text: "Measurement Setting", link: "/manage/measurement", icon: "" },
        device: { text: "Devices", link: "/manage/device", icon: "" },
        payment: { text: "Payment", link: "/manage/payment", icon: "" },
        priceupdate: { text: "Bulk Price Update", link: "/manage/priceupdate", icon: "" },
        taxrate: { text: "Tax Rate", link: "/manage/taxrate", icon: "" },
        campaign: { text: "Campaign", link: "/manage/campaign", icon: "" },
        combo: { text: "Combo", link: "/manage/combo", icon: "" },
        discount: { text: "Customized Discount", link: "/manage/discount", icon: "" }
      }
    },
    sales: {
      text: "POS Sales", link: "/pos", icon: ""
    },
    store: {
      text: "Store List", link: "/StoreList", icon: ""
    },
    admin: {
      text: "Admin",
      link: "#",
      icon: "",
      items: {
        bankdeposits: { text: "Bank Deposits", link: "/admin/bankdeposits", icon: "" },
        safemanagement: { text: "Safe Management", link: "/admin/safemanagement", icon: "" },
        cashregister: { text: "Cash Register", link: "/admin/cashregister", icon: "" },
        openOrders: { text: "Open Orders", link: "/admin/orders/open", icon: "" },
        shiftList: { text: "Shifts", link: "/admin/shift/list", icon: "" },
        shiftEdit: { text: "Manage Shift", link: "/admin/shift/edit", icon: "" },
        shiftAdd: { text: "Add New Shift", link: "/admin/shift/add", icon: "" },
        schedule: { text: "Schedule", link: "/admin/schedule", icon: "" },
        scheduleTimeSlots: { text: "Set Up Time Slots", link: "/admin/schedule/timeSlots", icon: "" },
        scheduleAdd: { text: "Add New Schedule", link: "/admin/schedule/add", icon: "" },
        scheduleEdit: { text: "Edit Schedule", link: "/admin/schedule/add", icon: "" }
      },
      common: {
        addQuestion: { label: "Add Question" },
        add: { label: "Add" },
        search: { label: "Search" }
      },
      marketing: {
        name: { label: "First Name", hintText: "First Name" },
        lastName: { label: "Last Name", hintText: "Last Name" },
        email: { label: "Email", hintText: "Email" },
        phoneNumber: { label: "Phone Number", hintText: "Phone Number" },
        gender: { label: "Gender", hintText: "Gender" },
        sendBy: { label: "Send by", hintText: "Send by" },
        ageFrom: { label: "Age from", hintText: "Age From" },
        ageTo: { label: "Age To", hitText: "Age To" }
      },
      orders: {
        text: "Orders",
        link: "/admin/orders",
        orderNumber: { label: "Order Number", hintText: "Order Number" },
        dateStart: { label: "Start Date", hintText: "Start Date" },
        dateEnd: { label: "End Date", hintText: "End Date" },
        orderStatus: { label: "Status", hintText: "Order Status" }
      },
      orderListTableColumns: [
        { key: "Id", label: "Order #", sortable: true },
        { key: "CreatedDate", label: "Order Date", sortable: true },
        { key: "PatientFirstName", label: "Recipient", visibleMode: "d-none-xs", sortable: true },
        { key: "EmployeeFirstName", label: "Employee", visibleMode: "d-none-xs", sortable: true },
        { key: "total", label: "Total", sortable: true }
      ],
      patientOrderListTableColumns: [
        { key: "Id", label: "Order #", sortable: true },
        { key: "CreatedDate", label: "Order Date", sortable: true },
        { key: "PatientFirstName", label: "Recipient", visibleMode: "d-none-xs", sortable: true },
        { key: "EmployeeFirstName", label: "Employee", visibleMode: "d-none-xs", sortable: true },
        { key: "total", label: "Total", sortable: true },
        { key: "MemberPriceSavings", label: "Member Savings" }
      ],
      prescriptionListTableColumns: [
        { key: "CreatedDate", label: "Created Date" },
        { key: "Note", label: "Note" },
        { key: "Options", label: "Options", visibleMode: "small-column" }
      ],
      orderApprovalsColumns: [
        { key: "employeeName", label: "Employee Name" },
        { key: "date", label: "Date" },
        { key: "approvalType", label: "Approval Type" }
      ],
      employeeShiftColumns: [
        { key: "date", label: "Date" },
        { key: "employeeFullName", label: "Full Name", visibleMode: "d-none-xs" },
        { key: "punchInDate", label: "Clock In" },
        { key: "punchOutDate", label: "Clock Out" },
        { key: "paidBreak", label: "Paid Break?", visibleMode: "d-none-xs" },
        { key: "status", label: "Status", visibleMode: "d-none-xs" }
      ],
      orderDetail: {
        text: "Order Details",
        link: "/admin/orders/detail",
        labels: {
          orderNumber: "Order Number",
          patientNumber: "Member Number",
          patientFirstName: "First Name",
          patientLastName: "Last Name",
          employee: "Employee Name",
          location: "Location",
          status: "Status",
          date: "Date",
          subTotal: "SubTotal",
          discountOnProduct: "Discount on Products",
          priceMatch: "Price Match+",
          subTotalIncludingDiscount: "SubTotal Including Discount",
          tips: "Tips",
          GST: "GST",
          PST: "PST",
          total: "Total",
          paid: "Paid",
          due: "Due",
          change: "Change",
          orderDate: "Order Date",
          generalDetails: "General Details",
          billingInfo: "Billing Details",
          shippingInfo: "Shipping Details",
          address: "Address",
          email: "Email",
          phone: "Phone",
          orderStatus: "Order Status",
          shippingFee: "Shipping Fee",
          payments: "Payment Received",
          onlineOrderCode: "Online Order#",
          deposit: "Deposit",
          terminal: "Terminal",
          branch: "Branch",
          storeCredit: "StoreCredit",
          storeCreditCode: "Store Credit Code",
          storeCreditCurrentValue: "Store Credit Current Amount",
          storeCreditValue: "Store Credit Amount",
        },
        itemsTable: {
          title: "Items"
        },
        tableColumns: [
          { key: "productName", label: "Product Name" },
          { key: "productPrice", label: "Price", width: "12%" },
          { key: "productQuantity", label: "Quantity", width: "12%" },
          { key: "productDiscount", label: "Discount", width: "12%" },
          { key: "productTotalPrice", label: "Total Price", width: "12%" },
          { key: "productStatus", label: "Status", width: "12%" }
        ],
        tableColumnsOrderHistory: [
          { key: "productName", label: "Product Name" },
          { key: "productPrice", label: "Price" },
          { key: "productQuantity", label: "Quantity" },
          { key: "productDiscount", label: "Discount" },
          { key: "productTotalPrice", label: "Total Price" },
          { key: "productStatus", label: "Status" }
        ],
        webOrderTableColumns: [
          { key: "productName", label: "Product Name" },
          { key: "productPrice", label: "Price" },
          { key: "productQuantity", label: "Quantity" },
          { key: "productDiscount", label: "Discount" },
          { key: "productTotalPrice", label: "Total Price" }
        ]
      },
      addMenu: {
        text: "Add Menu",
        link: "/admin/menu/add",
        menus: [
          { text: "Flowers", value: "Flowers" },
          { text: "Concentrates", value: "Concentrates" },
          { text: "Edibles", value: "Edibles" },
          { text: "Tropicals & Tinctures", value: "Tropicals & Tinctures" }
        ]
      },
      coupon: {
        text: "Coupon",
        link: "/admin/coupon",
        tableColumns: [
          { key: "couponName", label: "Coupon Name" },
          { key: "couponDate", label: "Date" },
          { key: "couponStatus", label: "Status" },
          { key: "couponEdit", label: "Edit" }
        ],
        controls: {
          addNewButton: "Add New Coupon",
          saveButton: "Save",
          editButton: "Edit"
        },
        labels: {
          couponName: { label: "Coupon Name", hintText: "Coupon Name" },
          startDate: { label: "Start Date", hintText: "Start Date" },
          endDate: { label: "End Date", hintText: "End Date" },
          discountType: { label: "Discount Type", hintText: "Discount Type" },
          discountValue: { label: "Discount Value", hintText: "Discount Value" },
          discountCode: { label: "Code", hintText: "Code" }
        },
        discountTypes: [
          { text: "%", value: "percentage" },
          { text: "$", value: "dollar" }
        ]
      },
      featuredProducts: {
        text: "Featured Products",
        link: "/admin/products/featured",
        labels: {
          productName: { label: "Search By Product's Name", hintText: "Coupon Name" },
          productCategory: { label: "Product Category", hintText: "Product Category" },
          productPriceMatrix: { label: "Price Matrix", hintText: "Price Matrix" }
        },
        featuredProductsTableColumns: [
          { key: "sku", label: "SKU" },
          { key: "name", label: "Name" },
          { key: "typeCategory", label: "Type and Category" },
          { key: "price", label: "Price" },
          { key: "icons", label: "Add To Slider" }
        ]
      },
      generalInfo: {
        text: "General Information",
        link: "/admin/general",
        labels: {
          shippingLocation: { label: "Shipping Location", hintText: "Shipping Location" },
          currencyOption: { label: "Currency Option", hintText: "Currency Option" },
          numberOfDecimal: { label: "Number of Decimal", hintText: "Number of Decimal" },
          siteTitle: { label: "Site Title", hintText: "Title of this site" },
          tagLine: { label: "Tag Line", hintText: "In a few words, explain what this stie is about." },
          title: { label: "Title", hintText: "Title" },
          adminEmail: { label: "Admin Email", hintText: "Admin Email" },
          description: { label: "Description", hintText: "Description" },
          instruction: { label: "Instruction", hintText: "Instruction" }
        },
        productReviewStatus: { label: "Product Review", hintText: "" },
        approvalByManager: { label: "Approval by Manager", hintText: "" },
        paymentOptionStatus: { label: "Status", hintText: "" },
        payment: {
          tableColumns: [
            { key: "gateway", label: "Gateway" },
            { key: "status", label: "Status" },
            { key: "icons", label: "" }
          ],
          title: "Manage Gateway"
        }
      },
      writing: {
        faq: {
          text: "FAQ",
          link: "/admin/writing/faq",
          title: "Manage FAQ",
          question: { label: "Question", hintText: "Question" },
          category: { label: "Category", hintText: "Category" },
          tableColumns: [
            { key: "question", label: "Question" },
            { key: "category", label: "Category" },
            { key: "icons", label: "" }
          ]
        },
        about: {
          text: "About",
          link: "/admin/writing/about",
          summary: { label: "Summary", hintText: "Summary" },
          title: "Manage About Page",
          sectionTitle: { label: "Section Title", hintText: "Section Title" },
          tableColumns: [
            { key: "section", label: "Section" },
            { key: "status", label: "Status" },
            { key: "icons", label: "" }
          ]
        },
        howTo: {
          text: "How-To",
          link: "/admin/writing/how-to",
          add: { label: "Add Section" },
          tableColumns: [
            { key: "title", label: "Title" },
            { key: "status", label: "Status" },
            { key: "icons", label: "" }
          ],
          edit: {
            text: "Manage How-To Page",
            link: "/admin/writing/how-to/save",
            title: { label: "Title", hintText: "Title" },
            instruction: { label: "Instruction Summary", hintText: "Instruction Summary" },
            step: { label: "Step Instruction", hintText: "Step Instruction" }
          }
        },
        legal: {
          text: "Legal",
          title: "Manage Legal Page",
          link: "/admin/writing/terms"
        },
        blog: {
          text: "Blog",
          link: "/admin/writing/blog",
          edit: {
            text: "Add Blog"
          }
        }
      },
      setting: {
        text: "Setting",
        link: "/admin/setting",
        prerollCategoryIdOption: [
          { text: "13", value: "13" },
          { text: "14", value: "14" },
          { text: "15", value: "15" }
        ],
        tokenName: { name: "tokenName", label: "Token Name", hintText: "Token Name" },
        deviceKeyName: { name: "deviceKeyName", label: "Device Key Name", hintText: "Device Key Name" },
        ageValidation: { name: "ageValidation", label: "Age Validation", hintText: "Age Validation" },
        storeCreditExpiration: { name: "StoreCreditExpirationDays", label: "Store Credit Expiration Days", hintText: "Store Credit Expiration Days" },
        memberDiscountPercentage: { name: "memberDiscountPercentage", label: "Member Discount Percentage", hintText: "Member Discount Percentage" },
        salesPersonDiscountThreshold: { name: "salesPersonDiscountThreshold", label: "Sales Manual Discount Cap", hintText: "Sales Manual Discount Cap" },
        cashInAmountByDefault: { name: "cashInAmountByDefault", label: "Default Cash-in Amount ($)", hintText: "Default Cash-in Amount" },
        cashDropAmount: { name: "cashDropAmount", label: "Cash-drop when cash flow Over ($)", hintText: "Cash-drop Over ($)" },
        suggestedCashDropAmount: { name: "suggestedCashDropAmount", label: "Suggested Cash-drop Amount", hintText: "Suggested Cash-drop Amount" },
        cashDropAmountToKeep: { name: "cashDropAmountToKeep", label: "Cash-drop Amount to Keep", hintText: "Cash-drop Amount to Keep" },
        preRollCategoryId: { name: "preRollCategoryId", label: "Pre-roll Category ID", hintText: "Pre-roll Category ID" },
        toleranceCashOutAmount: { name: "toleranceCashOutAmount", label: "Tolerance error Amount when Close Register ($)", hintText: "Tolerance Cash-out Amount" },
        doNotShowUnitProductQuantityOver: { name: "doNotShowUnitProductQuantityOver", label: "Show Unit Product Quantity up to (gram)", hintText: "Show Unit Product Quantity up to" },
        doNotShowWeightProductQuantityOver: { name: "doNotShowWeightProductQuantityOver", label: "Show Weight Product Quantity up to (gram)", hintText: "Show Weight Product Quantity up to" },
        numberOfCopies: { name: "numberOfCopies", label: "Number Of Receipt Copies", hintText: "Number Of Receipt Copies" },
        storeOpenHour: { name: "storeOpenHour", label: "Store Open Hour", hintText: "Store Open Hour" },
        storeCloseHour: { name: "storeCloseHour", label: "Store Close Hour", hintText: "Store Close Hour" },
        name: { name: "name", label: "Name", hintText: "Name" },
        phone: { name: "phone", label: "Phone", hintText: "Phone" },
        site: { name: "site", label: "Site", hintText: "Site" },
        street: { name: "street", label: "Street", hintText: "Street" },
        city: { name: "city", label: "City", hintText: "City" },
        provinceState: { name: "provinceState", label: "Province", hintText: "Province" },
        country: { name: "country", label: "Country", hintText: "Country" },
        email: { name: "email", label: "Email", hintText: "Email" },
        GSTNumber: { name: "gstNumber", label: "GSTNumber", hintText: "GSTNumber" },
        postalCode: { name: "postalCode", label: "Postal Code", hintText: "Postal Code" },
        crsaNumber: { name: "crsaNumber", label: "CRSA Number (Please Include CRSA in the header. e.g. CRSA1212121)", hintText: "CRSA Number(Please Include CRSA in the header. e.g. CRSA1212121)" },
        primaryContactFullName: { name: "primaryContactFullName", label: "Primary Contact FullName (First & Last)", hintText: "Primary Contact FullName (First & Last)" },
        primaryContactEmail: { name: "primaryContactEmail", label: "Primary Contact Email", hintText: "Primary Contact Email" },
        secondaryContactFullName: { name: "secondaryContactFullName", label: "Secondary Contact FullName (First & Last)", hintText: "Secondary Contact FullName (First & Last)" },
        secondaryContactEmail: { name: "secondaryContactEmail", label: "Secondary Contact Email", hintText: "Secondary Contact Email" },
        managementEmployeeCount: { name: "managementEmployeeCount", label: "Management Employee Count (fill if greater than 0)", hintText: "Management Employee Count (fill if greater than 0)" },
        administrativeEmployeeCount: { name: "administrativeEmployeeCount", label: "Administrative Employee Count (fill if greater than 0)", hintText: "Administrative Employee Count (fill if greater than 0)" },
        salesEmployeeCount: { name: "salesEmployeeCount", label: "Sales Employee Count (fill if greater than 0)", hintText: "Sales Employee Count (fill if greater than 0)" },
        productionEmployeeCount: { name: "productionEmployeeCount", label: "Production Employee Count (fill if greater than 0)", hintText: "Production Employee Count (fill if greater than 0)" },
        otherEmployeeCount: { name: "otherEmployeeCount", label: "Other Employee Count (fill if greater than 0)", hintText: "Other Employee Count (fill if greater than 0)" },
        logoutPinAfterSeconds: { name: "LogoutPinAfterSeconds", label: "Auto Logout PIN After (in seconds)", hintText: "in seconds" }
      },
      UIsetting: {
        text: "UI Settings",
        link: "/ecommerce/uisetting"
      },
      SEOSetting: {
        text: "SEO Settings",
        link: "/ecommerce/seosettings",
        updateSuccessMessage: "Settings updated successfully",
        updateErrorMessage: "Settings updated failed"
      },
      communicating: {
        text: "Marketing",
        link: "/admin/marketing",
        sendBy: [
          { text: "Email", value: "Email" },
          { text: "SMS", value: "SMS" }
        ],
        columns: [
          { key: "Id", label: "ID", visibleMode: "d-none-sm", sortable: true },
          { key: "FirstName", label: "Full Name", sortable: true },
          { key: "Icons", label: "" }
        ],
        columnsEmail: [
          { key: "Id", label: "ID", visibleMode: "d-none-sm", sortable: true },
          { key: "FirstName", label: "Full Name", sortable: true },
          { key: "Email", label: "Email Address", sortable: true },
          { key: "Icons", label: "" }
        ],
        columnsSMS: [
          { key: "Id", label: "ID", visibleMode: "d-none-sm", sortable: true },
          { key: "FirstName", label: "Full Name", sortable: true },
          { key: "SMS", label: "Phone Number", sortable: true },
          { key: "Icons", label: "" }
        ]
      },
      SEOSetting: {
        text: "Banner List",
        link: "/ecommerce/bannerList",
        updateSuccessMessage: "banners updated successfully",
        updateErrorMessage: "Banners updated failed"
      },
    },
    test: { text: "Test", link: "/test", icon: "" },
    help: { text: "Help", link: "/help", icon: "" }
  },
  pos: {
    messages: {
      noPatientSelectedCannabisProduct: "In order to sell a cannabis-based product, you should link the Member to the order by clicking on the 'Member Search' button.",
      noQuantitySelectedUnitProduct: "In order to add a product to the order list, you should select a quantity value greater than 0.",
      noPriceMatrixSelectedUnitProduct: "In order to add a product to the order list, you should select a price from the price matrix table.",
      noPackageReferenceUnitProduct: "In order to add a product to the order list, you should select a valid Lot Number.",
      errorSave: "An error occurred while saving the Order's info, please try again later. If the error persists, please contact the store administrator.",
      voidItemError: "An error occurred while voiding an item from the Order's info, please try again later. If the error persists, please contact the store administrator.",
      invalidCredentials: "The provided credential does not have enough privilege to approve this cancellation.",
      invalidCredentialsDiscount: "The provided credential does not have enough privilege to approve this discount.",
      invalidCredentialsRefund: "The provided credential does not have enough privilege to approve this refund.",
      invalidCredentialsAllowOption: "The provided credential does not have enough privilege to approve this option.",
      unavailableProductStock: "The added product is currently unavailable in stock for the requested amount.",
      orderNotFound: "The requested order does not exists.",
      emailReceiptSent: "The email receipt was sent to the customer.",
      smsReceiptSent: "The SMS receipt was sent to the customer.",
      fulfillmentSent: "Send to fulfillment success",
      emailReceiptNotSent: "An error occurred while sending email receipt to customer, please try again later. If the error persists, please contact the store administrator.",
      emailReceiptInvalid: "An error occurred while sending email receipt to customer, please verify the Member email because it is invalid.",
      productWarehouseNotFound: "The product is not available or not exists.",
      InactiveProductException: "The product is inactive. Check the product details to activate the product.",
      invalidQuantityForProduct: "The quantity for this product is invalid, please contact the store administrator.",
      invalidQuantityForOrder: "This order is exceeding the allowed quantity.  Limit is 30g",
      limitInGramsExceeded: "'Change this', limit of grams exceeded",
      storeCreditInSufficient: "The value of the store credit is not sufficient",
      noStoreCreditAvailable: "There is no active store credit available with the code provided",
      smsNotSent: "SMS Was Not Sent",
      orderAlreadyCompleted: "Cancel or void fail, this order has already been completed / voided / cancelled, please hard refresh the system to get the latest status.",
      closeOpenOrders: "System detects you have old open orders. Do you want to close them?",
      closeOpenOnlineOrders: "System detects you have open unpaid online orders. Do you want to close them?",
      orderAfterStoreHours: "No sale is allowed after store hours!",
      orderAlreadyDone: "This order is either completed or cancelled, please refresh and try again.",
      TotalDiscountBigger: "Total Discounts is bigger than order Total ",
      OrderNotCreatedToday: "This order was not created today. Please cancel and recreate the order again!",
      orderUpdatedElsewhereMessage: "This order has been updated elsewhere. Please refresh the page and try again",
      fulfillmentManagerApprovalMessage: "An approval by the management team is necessary to select lot numbers, please ask for management team to approve this option.",
      priceMatchCanNotAdded: "You must set match price before enabling Price Match+.",
      productDiscountNote: "Please enter a note for each product that has a discount.",
      CannotRefundGiftCard: "This gift card has been used before and cannot be refunded."
    },
    basicCategories: [
      { text: "Cannabis", value: "1" },
      { text: "Accessories", value: "2" },
      { text: "All", value: "3" }
    ],
    vapeCategories: [
      { text: "Vape", value: "1" },
      { text: "All", value: "2" }
    ],
    //multiplesToWithDraw: 20,
    titles: {
      pos: "POS Sales",
      closeOpenOrders: "CLOSE OPEN ORDERS",
      closeOpenOnlineOrders: "CLOSE OPEN ONLINE ORDERS"
    },
    filters: {
      categories: { label: "Categories" },
      productName: { label: "Product Name", hintText: "Search by Product Name" }
    },
    patientDialog: {
      search: {
        cardNumber: { label: "Card Number", hintText: "Input Card Number" },
        firstName: { label: "First Name", hintText: "Type Member's first name" },
        lastName: { label: "Last Name", hintText: "Type Member's last name" },
        preferredName: { label: "Preferred Name", hintText: "Type Member's preferred name" },
        email: { label: "Email", hintText: "Type Member's email" },
        phone: { label: "Phone", hintText: "Type Member's phone" },
        memberNumber: { label: "Member Number", hintText: "Type Member's member number" },
        isNotMember: { label: "Non member" },
        searchButton: "SEARCH",
        addToOrderButton: "START ORDER",
        viewOrderButton: "VIEW ORDER HISTORY",
        viewMemberButton: "VIEW MEMBER"
      }
    },
    addProductDialog: {
      amount: { label: "Weight (g)", hintText: "Weight (g)" },
      tableColumns: [
        { key: "weightSetting", label: "Weight Setting", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "price", label: "Price", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "memberPrice", label: "Member Price", visibleMode: "visible-lg visible-xs visible-sm visible-md" }
      ],
      RetailtableColumns: [
        { key: "weightSetting", label: "Weight Setting", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "price", label: "Price", visibleMode: "visible-lg visible-xs visible-sm visible-md" }
      ]
    },
    openRefundDialog: {
      title: "Open the order",
      message: "Please fill the order number to reopen the order.",
      orderNumber: { label: "Order Number", hintText: "Order Number" }
    },
    applyDiscountDialog: {
      title: "Order Cancellation",
      credentialsTitle: "Management Team Credential",
      pincodeTitle: "Pin Code",
      alertMessage: "An approval by the management team is necessary to apply discount in this order, please ask for management team to approve this discount.",
      amount: { label: "Amount for discount (Maximum accounts for cost)", hintText: "Amount (Maximum accounts for cost) for discount" },
      userName: { label: "Management Team User Name", hintText: "Management Team User Name" },
      password: { label: "Management Team Password", hintText: "Management Team Password" },
      saveSuccessMessage: "Discount applied successfully.",
      saveErrorMessage: "An error occurred when applying discount to the order, please try again. If the error persists, please contact the administrator.",
      warning: "Warning⚠️",
      belowMarginMessage: "Adding this discount will set your products below 15% profit margin.",
      belowCostMessage: "Adding this discount will set your products prices below their costs."
    },
    removeDiscountDialog: {
      title: "Remove Discount - Order#",
      saveSuccessMessage: "Discount removed successfully.",
      saveErrorMessage: "An error occurred while removing the discount of the order, please try again. If the error persists, please contact the administrator."
    },
    cancellationDialog: {
      title: "Order Cancellation",
      alertMessage: "An approval by the management team is necessary to cancel this order, please ask for management team to approve this cancelation. You need to return Cash to customers if they have paid paidpartially. Once cancelled you are not able to open this order again.",
      alertMessageNoNeedApproval: "Are you sure to cancel this order?",
      credentialsTitle: "Management Team Credential",
      pincodeTitle: "Pin Code",
      userName: { label: "Management Team User Name", hintText: "Management Team User Name" },
      password: { label: "Management Team Password", hintText: "Management Team Password" }
    },
    existingOrderDialog: {
      title: "Order already exists",
      message: "An order already exists for this Member. Would you like to continue the order ?"
    },
    confirmOverwriteUPCDialog: {
      title: "UPC already exists",
      message: "This UPC has been used. Do you want to change the UPC to this product?  (The UPC for the previous product will be cleared, you can only do it for accessory products). Previous product name is "
    },
    closeRegisterDialog: {
      title: "Close Register",
      message: "Are you sure ?"
    },
    removeRefundDialog: {
      alertMessage: "Select one or more products to undo the refund process:",
      saveSuccessMessage: "Remove refund applied successfully.",
      saveErrorMessage: "An error occurred when removing refund from the order, please try again. If the error persists, please contact the administrator."
    },
    applyRefundDialog: {
      title: "Order Cancellation",
      credentialsTitle: "Management Team Credential",
      pincodeTitle: "Pin Code",
      alertMessage: "An approval by the management team is necessary to apply refund in this order, please ask for management team to approve this refund.",
      amount: { label: "Amount for discount", hintText: "Amount for discount" },
      userName: { label: "Management Team User Name", hintText: "Management Team User Name" },
      password: { label: "Management Team Password", hintText: "Management Team Password" },
      saveSuccessMessage: "Refund applied successfully.",
      saveErrorMessage: "An error occurred when applying refund to the order, please try again. If the error persists, please contact the administrator.",
      tableColumns: [
        { key: "Product", label: "Product" },
        { key: "Quantity", label: "Quantity" },
        { key: "Reason", label: "Reason" }
      ]
    },
    controls: {
      addProductButton: "Add Product To Order"
    },
    payments: {
      amount: { label: "Amount received from customer", hintText: "Amount received from customer", online: "Amount paid online" },
      receiptNumber: { label: "Receipt Number", hintText: "Receipt Number" },
      storeCreditCode: { label: "Store Credit Code", hintText: "Store Credit Code" },
      giftCard: {
        pan: { label: "Card number", hintText: "Card number" },
        pin: { label: "PIN", hintText: "PIN" },
        expdate: { label: "Expire date (Optional)", hintText: "Expire date (Optional)" },
        cvd_vale: { label: "Card validation code" },
        processMethod: { label: "Process method" }
      }
    },
    recentOrdersDialog: {
      tableColumns: [
        { key: "Id", label: "Order#", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "PatientId", label: "Member#", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "Patient", label: "Member", visibleMode: "visible-lg" },
        { key: "Total", label: "Total", visibleMode: "visible-lg" },
        { key: "Date", label: "Date and Time", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "Icons", label: "", visibleMode: "visible-lg visible-xs visible-sm visible-md" }
      ],
      retailTableColumns: [
        { key: "Id", label: "Order#", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "OnlineOrderId", label: "Queued Order #", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "Patient", label: "Member", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "Total", label: "Total", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "Date", label: "Date and Time", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "Icons", label: "", visibleMode: "visible-lg visible-xs visible-sm visible-md" }
      ]
    },
    inventoryFlagDialog: [
      { key: "SKU", label: "SKU", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
      { key: "Name", label: "Name", visibleMode: "visible-lg" },
      { key: "TotalQuantity", label: "Total Quantity", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
      { key: "Icons", label: "", visibleMode: "visible-lg visible-xs visible-sm visible-md" }
    ],
    tableProductDiscount: [
      { key: "Name", label: "Name" },
      { key: "OriginalPrice", label: "Previous Price($)" },
      { key: "DiscountType", label: "Discount Type" },
      { key: "DiscountAmount", label: "Discount Amount" },
      { key: "PriceMatch", label: "Price Match +" },
    ],
    tableProductPriceMatch: [
      { key: "Name", label: "Name" },
      { key: "CurrentPrice", label: "Current Price($)" },
      { key: "PriceMatchPlus", label: "Price Match Plus" },
      { key: "DiscountAmount", label: "Discount Amount" },
      { key: "NewPrice", label: "New Price ($)" }
    ],
    tableProductDiscountAlpine: [
      { key: "Name", label: "Name" },
      { key: "OriginalPrice", label: "Original Price($)" },
      { key: "DiscountType", label: "Discount Type" },
      { key: "DiscountAmount", label: "Discount Amount" },
      { key: "NewPrice", label: "New Price ($)" },
      { key: "AlpineIQDiscount", label: "Alpine IQ Discount" }
    ],
    giftCard: {
      initialization: { label: "Gift Card Initialization" },
      dataInquiry: { label: "Gift Card Inquiry" },
      checkBalance: { label: "Check Card Balance" },
      activation: { label: "Gift Card Activation / Reload" },
      deactivation: { label: "Git Card Deactivation" },
      pan: { label: "Card Number", hintText: "Card Number" },
      pin: { label: "PIN Number", hintText: "PIN Number" },
      transId: { label: "Transaction Id", hintText: "Transaction Id" },
      ErnexNo: { label: "Ernex Number", hintText: "Ernex Number" },
      expdate: { label: "Expiry Date (Optional, Format: YYMM)", hintText: "Expiry Date (Optional, Format: YYMM)" },
      cvdValue: { label: "Card Validation Code", hintText: "Card Validation Code" },
      initAmount: { label: "Initial Amount (Keep 0 if card card only supports a fixed initial amount)", hintText: "Initial Amount (Keep 0 if card only supports a fixed initial amount)" },
      activationAmount: { label: "Activation Amount", hintText: "Activation Amount" },
      tcrNumber: { label: "Reference transaction confirmation number", hintText: "Reference transaction confirmation number" },
      cancel: { label: "Reverse Actication/Reload", hintText: "Reverse Actication/Reload" },
      readyToSwipeCard: { text: "Please fill up the following info and ready to swipe the gift card" }
    }
  },
  priceMatrix: {
    id: { label: "Id", hintText: "Id" },
    name: { label: "Name", hintText: "Type price matrix's name" },
    status: { label: "Status", hintText: "" },
    settings: {
      price: { label: "Price", hintText: "Price" },
      tableColumns: [
        { key: "WeightSetting", label: "Weight Setting", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "Price", label: "Price", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "MemberPrice", label: "Member Price", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "Status", label: "Campaign Active", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "icon", label: "", visibleMode: "lg" }
      ],
      tableColumnsRetail: [
        { key: "WeightSetting", label: "Weight Setting", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "Price", label: "Price", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "", label: "", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "Status", label: "Campaign Active", visibleMode: "visible-lg visible-xs visible-sm visible-md" },
        { key: "icon", label: "", visibleMode: "lg" }
      ]
    },
    patientView: {
      tableColumns: [
        { key: "WeightSetting", label: "Weight Setting" },
        { key: "Price", label: "Price" },
        { key: "MemberPrice", label: "Member Price", visibleMode: "d-none-xs" },
        { key: "Icon", label: "Print Label", visibleMode: "center-th" }
      ],
      tableColumnsRetail: [
        { key: "WeightSetting", label: "Weight Setting" },
        { key: "Price", label: "Price" },
        { key: "Icon", label: "Print Label", visibleMode: "center-th" }
      ]
    },
    tableColumns: [
      { key: "Id", label: "ID#", visibleMode: "d-none-xs" },
      { key: "Name", label: "Name" },
      { key: "Status", label: "Status", visibleMode: "d-none-xs" },
      { key: "NumberOfProducts", label: "Number of Products", visibleMode: "d-none-xs" },
      { key: "Icons", label: "" }
    ],
    controls: {
      addNewButton: "Add New Price Matrix",
      saveButton: "Save",
      cancelButton: "Cancel",
      applyMemberPrice: "Apply Member Price"
    },
    titles: {
      list: "Price Matrix",
      manage: "Manage Price Matrix"
    },
    messages: {
      createdMessage: "Price Matrix created successfully.",
      editedMessage: "Price Matrix edited successfully.",
      saveErrorMessage: "An error occurred when saving the Price Matrix's information, please try again. If the error persists, please contact the administrator."
    }
  },
  productCategory: {
    name: { label: "Name", hintText: "Name" },
    type: { label: "Type", hintText: "Select a type" },
    isCannabis: { label: "Cannabis Infused", hintText: "Cannabis Infused" },
    isVape: { label: "Vape Product", hintText: "“Vape Product" },
    status: { label: "Status", hintText: "Status" },
    isRefundable: { label: "Refundable", hintText: "Refundable" },
    classOfCannabis: { label: "Class of Cannabis", hintText: "Class of Cannabis" },
    bcCannabisClassLabel: { label: "BC Cannabis Type", hintText: "BC Cannabis Type" },
    mbCannabisClassLabel: { label: "MB Cannabis Type", hintText: "MB Cannabis Type" },
    unitOfMeasurementLabel: { label: "Unit Of Measurement", hintText: "Unit Of Measurement" },
    priceMargin: { label: "Price Margin Percentage", hintText: "Price Margin Percentage" },
    priceValue: { label: "Price Per Unit Amount", hintText: "Price Per Unit Amount" },
    pricePersent: { label: "Price Per Unit Percentage", hintText: "Price Per Unit Percentage" },
    titles: {
      add: "Add New Product Category",
      edit: "Edit Product Category"
    },
    controls: {
      saveButton: "Save",
      cancelButton: "Cancel",
      aggressiveMode: "Run Aggressive Mode",
      normalMode: "Run Normal Mode"
    },
    tableColumns: [
      { key: "id", label: "ID", visibleMode: "d-none-sm" },
      { key: "name", label: "Name" },
      { key: "isCannabis", label: "Cannabis Based" },
      { key: "status", label: "Status", visibleMode: "d-none-sm" },
      { key: "icons", label: "" }
    ],
    bcCannabisClass: [
      { text: "None", value: 0 },
      { text: "Seeds", value: 1 },
      { text: "Vegatative Cannabis Plants", value: 2 },
      { text: "Fresh Cannabis", value: 3 },
      { text: "Dried Cannabis", value: 4 },
      { text: "Edibles Solids", value: 5 },
      { text: "Edibles Non Solids", value: 6 },
      { text: "Extracts Inhaled", value: 7 },
      { text: "Extracts Ingested", value: 8 },
      { text: "Extracts Others", value: 9 },
      { text: "Topicals", value: 10 },
      { text: "Other", value: 11 }
    ],
    unitOfMeasurement: [
      { text: "None", value: 0 },
      { text: "%", value: 1 },
      { text: "mg/each", value: 2 },
      { text: "mg/cap", value: 3 },
      { text: "mg/ml", value: 4 },
      { text: "mg/unit", value: 5 },
      { text: "mg/pack", value: 6 },
      { text: "mg/spray", value: 7 },
      { text: "mg/bottle", value: 8 },
      { text: "mg/g", value: 9 },
      { text: "mg", value: 10 },
    ],
    tableColumnsBulkUpdatePriceHistory: [
      { key: "userTitle", label: "Employee Name" },
      { key: "creationDate", label: "Date Created" },
      { key: "priceValue", label: "Price Value" },
      { key: "bulkPriceValueType", label: "Price Value Type" },
      { key: "priceByCategoryMode", label: "Price By Category Mode" },
      { key: "updateCount", label: "Quantity" }
    ],
    createdMessage: "Category created successfully.",
    editedMessage: "Category edited successfully.",
    saveErrorMessage: "An error occurred when saving the category's information, please try again. If the error persists, please contact the administrator."
  },

  inventoryAudit: {
    listTitle: "Inventory Audit List",
    viewTitle: "Inventory Audit",
    addTitle: "Add Inventory Audit",
    listTableColumns: [
      { key: "id", label: "Id", sortable: true, width: '10%' },
      { key: "name", label: "Name", sortable: true, width: '25%' },
      { key: "date", label: "Date Modified", sortable: true, width: '' },
      { key: "productCount", label: "Product Count", sortable: false, width: '' },
      { key: "status", label: "Status", sortable: false, width: '' },
      { key: "edit", label: "", sortable: false, width: '230px' }
    ],
    auditTableManagerColumns: [
      { key: "name", label: "Product Name", sortable: true, width: '15%' },
      { key: "sku", label: "SKU", sortable: true },
      { key: "location", label: "Location" },
      { key: "warehouseType", label: "Warehouse", sortable: true },
      { key: "newquantity", label: "Counted Quantity", sortable: true },
      { key: "expectedQty", label: "Expected Quantity", sortable: false },
      { key: "differenceQty", label: "Difference Quantity{$0}", sortable: false },
      { key: "differenceCost", label: "Difference Cost (From WAC){$1}", sortable: false },
      { key: "notes", label: "Notes", sortable: false },
      { key: "delete", label: "Remove Product", width: '120px' }
    ],
    auditTableColumns: [
      { key: "name", label: "Product Name", sortable: true, width: '15%' },
      { key: "location", label: "Location" },
      { key: "warehouseType", label: "Warehouse", sortable: true },
      { key: "sku", label: "SKU", sortable: true },
      { key: "newquantity", label: "New Quantity", sortable: false },
      { key: "notes", label: "Notes", sortable: false },
      { key: "delete", label: "Remove Product", width: '120px' }
    ],
    verifyAuditTableColumns: [
      { key: "name", label: "Product Name", sortable: false },
      { key: "date", label: "Saved Date", sortable: false },
      { key: "currentquantity", label: "Current", sortable: false },
      { key: "auditquantity", label: "Audit", sortable: false },
      { key: "adjust", label: "Adjust", sortable: false }
    ],
    adjustauditTableColumns: [
      { key: "warehouseId", label: "Warehouse Type", visibleMode: "d-none-xs", sortable: false },
      { key: "packageReference", label: "Package Reference", sortable: false },
      { key: "quantity", label: "Current Quantity", sortable: false },
      { key: "pendingTransfer", label: "Pending Outward Transfer", sortable: false }
    ],
    messages: {
      createdMessage: "Inventory Audit created successfully.",
      editedMessage: "Inventory Audit edited successfully.",
      saveErrorMessage: "An error occurred when saving the Audit's information, please try again. If the error persists, please contact the administrator."
    }
  },
  product: {
    listTitle: "Product List",
    viewTitle: "Product View",
    sku: { label: "SKU", hintText: "Type product's SKU" },
    upc: { label: "UPC", hintText: "Scan product's UPC" },
    barcode: { label: "Barcode", hintText: "Type product's barcode" },
    name: { label: "Name", hintText: "Type product's name" },
    webName: { label: "Web Name", hintText: "Type product's Webname" },
    size: { label: "size", hintText: "size" },
    baseCost: { label: "Base Cost", hintText: "Product's base cost" },
    unitPrice: { label: "Unit Price", hintText: "Type product's unit price" },
    promotionUnitPrice: { label: "Promotion Unit Price", hintText: "Type product's unit price" },
    memberUnitPrice: { label: "Member Unit Price", hintText: "Type product's member unit price" },
    eliteMemberUnitPrice: { label: "Elite Member Unit Price", hintText: "Type product's elite member unit price" },
    priceMatrix: { label: "Price Matrix", hintText: "Select a Price Matrix" },
    weight: { label: "Weight", hintText: "Select a Weight" },
    type: { label: "Type", hintText: "Select a type" },
    description: { label: "Description", hintText: "Description for web menu" },
    brand: { label: "Brand", hintText: "Brand" },
    unitOfMeasurement: { label: "UoM", hintText: "Select the unit of measurement" },
    quantity: { label: "Quantity", hintText: "0.00" },
    category: { label: "Category", hintText: "Select a category" },
    subCategory: { label: "subCategory", hintText: "Select a sub category" },
    species: { label: "Species", hintText: "Select the Species" },
    price: { label: "Price", hintText: "0.00" },
    status: { label: "Status", hintText: "Status" },
    legalBarcode: { label: "Legal Barcode", hintText: "LegalBarcode" },
    depositEnabled: { label: "Deposit Enabled", hintText: "Deposit Enabled" },
    webmenuDisplayedEnabled: { label: "Web Menu Display", hintText: "Web Menu Display" },
    isElite: { label: "Is Elite Product", hintText: "Is Elite" },
    depositAmount: { label: "Deposit Amount", hintText: "Deposit Amount" },
    dfe: { label: "Dried Flower Equivalent(g/unit)", hintText: "Dried Flower Equivalent(g/unit)" },
    thcmin: { label: "THC Min", hintText: "THC Min" },
    thcmax: { label: "THC Max", hintText: "THC Max" },
    cbdmin: { label: "CBD Min", hintText: "CBD Min" },
    cbdmax: { label: "CBD Max", hintText: "CBD Max" },
    thc: { label: "THC Exact", hintText: "THC Exact" },
    cbd: { label: "CBD Exact", hintText: "CBD Exact" },
    controls: {
      addButton: "Add",
      saveButton: "Save",
      cancelButton: "Cancel"
    },
    tableColumns: [
      { key: "sku", label: "SKU", visibleMode: "d-none-xs", sortable: true },
      { key: "name", label: "Name", sortable: true },
      { key: "category", label: "Category", sortable: true },
      { key: "typeId", label: "Type", sortable: true, visibleMode: "d-none-xs" },
      { key: "status", label: "Status", sortable: true, visibleMode: "d-none-xs" },
      { key: "price", label: "Price", sortable: true },
      { key: "icons", label: "", visibleMode: "d-none-xs" }
    ],
    tableColumnsWithMember: [
      { key: "sku", label: "SKU", visibleMode: "d-none-xs", sortable: true, width: '10%' },
      { key: "name", label: "Name", sortable: true },
      { key: "category", label: "Category", sortable: true, width: '15%' },
      { key: "typeId", label: "Type", sortable: true, visibleMode: "d-none-xs", width: '10%' },
      { key: "status", label: "Status", sortable: true, visibleMode: "d-none-xs", width: '10%' },
      { key: "price", label: "Regular/ Member", sortable: true, width: '22%' },
      { key: "icons", label: "", visibleMode: "d-none-xs", width: '80px' }
    ],
    tableColumnsWithMemberElitePrice: [
      { key: "sku", label: "SKU", visibleMode: "d-none-xs", sortable: true, width: '10%' },
      { key: "name", label: "Name", sortable: true },
      { key: "category", label: "Category", sortable: true, width: '15%' },
      { key: "typeId", label: "Type", sortable: true, visibleMode: "d-none-xs", width: '10%' },
      { key: "status", label: "Status", sortable: true, visibleMode: "d-none-xs", width: '10%' },
      { key: "price", label: "Regular/ Promotion/ Member/ EliteMember Price", sortable: true, width: '22%' },
      { key: "icons", label: "", visibleMode: "d-none-xs", width: '80px' }
    ],
    tableColumnsWithMemberPromotionPrice: [
      { key: "sku", label: "SKU", visibleMode: "d-none-xs", sortable: true, width: '10%' },
      { key: "name", label: "Name", sortable: true },
      { key: "category", label: "Category", sortable: true, width: '15%' },
      { key: "typeId", label: "Type", sortable: true, visibleMode: "d-none-xs", width: '10%' },
      { key: "status", label: "Status", sortable: true, visibleMode: "d-none-xs", width: '10%' },
      { key: "price", label: "Regular/ Promotion/ Member", sortable: true, width: '22%' },
      { key: "icons", label: "", visibleMode: "d-none-xs", width: '80px' }
    ],
    tableSKUMapping: [
      { key: "SupplierProductCode", label: "ProductCode" },
      { key: "CaseQty", label: "CaseQty" },
      { key: "SupplierName", label: "SupplierName" },
      { key: "WholeSale", label: "WholeSale" },
      { key: "ProvinceCode", label: "ProvinceCode" },
      { key: "THC_Range", label: "THC_Range" },
      { key: "CBD_Range", label: "CBD_Range" },
      { key: "THC", label: "THC" },
      { key: "CBD", label: "CBD" }
    ],
    tableSKUMappingForUpdate: [
      { key: "SupplierProductCode", label: "ProductCode" },
      { key: "CaseQty", label: "CaseQty" },
      { key: "SupplierName", label: "SupplierName" },
      { key: "WholeSale", label: "WholeSale" },
      { key: "ProvinceCode", label: "ProvinceCode" },
      { key: "IconDelete", label: "Delete" }
    ],
    dashBoardTable: [
      { key: "productName", label: "Product" },
      { key: "totalSold", label: "Quantity" }
    ],
    messages: {
      createdMessage: "Product created successfully.",
      editedMessage: "Product edited successfully.",
      saveErrorMessage: "An error occurred when saving the Product's information, please try again. If the error persists, please contact the administrator.",
      ValueNotValid: "Value Not Valid!"
    },

    titles: {
      add: "Add New Product",
      edit: "Manage Product"
    },
    filters: {
      name: { label: "Name", hintText: "Name" },
      category: { label: "Category", hintText: "Category" },
      skuNumber: { label: "SKU", hintText: "SKU" },
      brand: { label: "Brand", hintText: "Brand" },
      species: { label: "Species", hintText: "Species" },
      onHold: { label: "OnHold", hintText: "OnHold" },
      filterButton: "Filter",
      cleanFilterButton: "Clean"
    },
    inventoryAdjustFilters: {
      name: { label: "Product Name", hintText: "Product Name" },
      sku: { label: "Product SKU", hintText: "Product SKU" },
      po: { label: "PO #", hintText: "PO #" },
      displayName: { label: "Digital Signage Display Name", hintText: "Digital Signage Display Name" },
      category: { label: "Category Name", hintText: "Category Name" },
      productId: { label: "Product Id", hintText: "ProductId" },
      filterButton: "Filter",
      cleanFilterButton: "Clean",
      showAdvancedCheckbox: "Show Advanced Options",
      showOnlyInStockToggle: "Show Only In Stock",
      species: { label: "Species", hintText: "Species" }
    },
    inventoryAdjustTable: {
      displayName: { label: "Display Name", hintText: "Display Name" },
      showInDS: { label: "Display", hintText: "Display" },
      estimatedQty: { label: "Esitmated Quantity", hintText: "Esitmated Quantity" },
      salePrice: { label: "Sale Price", hintText: "Sale Price" },
      avgPOPrice: { label: "Avg Purchase Price", hintText: "Avg Purchase Price" },
      margin: { label: "margin", hintText: "margin" },
      location: { label: "location", hintText: "location" }
    },
    bulkTransferProductDetails: {
      from: { from: "From Sender", hintText: "From Sender" },
      to: { to: "To Receiver", hintText: "To Receiver" },
      note: { note: "Notes", hintText: "Notes" }
    },
    printLabelDialog: {
      title: "Print Label",
      print: { label: "Print" }
    },
    tableColumnsBulkMemberPriceHistory: [
      { key: "userTitle", label: "Employee Name" },
      { key: "creationDate", label: "Date Created" },
      { key: "memberDiscountPercentage", label: "Discount%" },
      { key: "updateCount", label: "Quantity" }
    ],
    tableColumnsBulkMemberPriceCategoryHistory: [

      { key: "userTitle", label: "Employee Name" },
      { key: "creationDate", label: "Date Created" },
      { key: "memberDiscountPercentage", label: "Discount%" },
      { key: "updateCount", label: "Quantity" }
    ]
  },
  vendor: {
    listTitle: "Vendor List",
    createdMessage: "Vendor created successfully.",
    editedMessage: "Vendor edited successfully.",
    saveErrorMessage: "An error occurred when saving the vendor's information, please try again. If the error persists, please contact the administrator.",
    id: { label: "ID Number", hintText: "ID Number" },
    name: { label: "Business Name", hintText: "Business Name" },
    licenseNumber: { label: "License Number", hintText: "License Number" },
    category: { label: "Business Category", hintText: "Business Category" },
    website: { label: "Website", hintText: "Website" },
    address: { label: "Address", hintText: "Address" },
    state: { label: "State", hintText: "State" },
    city: { label: "City", hintText: "City" },
    postalCode: { label: "Postal Code", hintText: "Postal Code" },
    phone: { label: "Contact Phone", hintText: "Contact Phone" },
    contact: { label: "Contact Name", hintText: "Contact Name" },
    email: { label: "Contact Email", hintText: "Contact Email" },
    status: { label: "Status", hintText: "Status" },
    tableColumns: [
      { key: "id", label: "ID#", visibleMode: "d-none-sm", width: "100px" },
      { key: "name", label: "Name" },
      { key: "licenseNumber", label: "License #", visibleMode: "d-none-sm" },
      { key: "category", label: "Category", visibleMode: "d-none-sm" },
      // { key: "contact", label: "Contact" },
      { key: "phone", label: "Phone" },
      { key: "email", label: "Email" },
      // { key: "status", label: "Status" },
      { key: "icons", label: "", visibleMode: "visible-lg", width: "100px" }
    ],
    accessoryVendorCatalogTableColumns: [
      { key: "logo", label: "Logo" },
      { key: "name", label: "Name" },
      { key: "icons", label: "Actions" }
    ],
    controls: {
      addNewButton: "Add New Vendor",
      editButton: "Edit",
      saveButton: "Save",
      cancelButton: "Cancel"
    },
    messages: {
      createdMessage: "Vendor created successfully.",
      editedMessage: "Vendor edited successfully.",
      saveErrorMessage: "An error occurred when saving the Vendor's information, please try again. If the error persists, please contact the administrator."
    }
  },
  cashFlowInfo: {
    dashBoardTable: [
      { key: "station", label: "Station" },
      { key: "employee", label: "Employee" },
      { key: "cashIn", label: "Cash-In Time", visibleMode: "visible-lg border-right" },
      { key: "cashDrop", label: "Last Cash Drop", visibleMode: "visible-lg border-right" },
      { key: "cashOut", label: "Cash-Out Time" }
    ],
    cashFlowCountType: {
      CashIn: 1,
      CashDrop: 2,
      CashOut: 3
    }
  },
  category: {
    id: "ID",
    name: { label: "Name", hintText: "Name" },
    status: { label: "Status", hintText: "Status" },
    controls: {
      saveButton: "Save"
    }
  },
  purchaseOrder: {
    createdMessage: "Purchase Order created successfully.",
    editedMessage: "Purchase Order edited successfully.",
    openedMessage: "Purchase Order opened successfully.",
    onOrderMessage: "Purchase Order verified successfully.",
    cancelledMessage: "Purchase Order cancelled successfully.",
    saveStatusErrorMessage: "An error occurred when chaging the purchase order's Status, please try again. If the error persists, please contact the administrator.",
    saveErrorMessage: "An error occurred when saving the purchase order's information, please try again. If the error persists, please contact the administrator.",
    poNumber: "PO Number",
    vendor: "Vendor",
    paymentDate: { label: "Payment Due Date", hintText: "" },
    dateExpected: { label: "Date Expected", hintText: "" },
    discount: "Discount",
    name: { label: "PO Description", hintText: "PO Description" },
    supplierInvoiceNumber: { label: "Supplier Invoice Number", hintText: "Supplier Invoice Number" },
    package: { label: "Package", hintText: "Package Number" },
    unitPrice: { label: "Unit Price", hintText: "Unit Price" },
    totalPrice: { label: "Total Price", hintText: "Total Price" },
    price: { label: "Total Price", hintText: "Total Price" },
    tax: { label: "Tax %", hintText: "Tax %" },
    location: { label: "Location", hintText: "Location" },
    subTotal: "SubTotal",
    totalPayment: "Total Payment Due",
    comment: "Comment",
    status: "Status",
    tableColumns: [
      { key: "ID", label: "PO#", sortable: true, width: "10%" },
      { key: "Supplier", label: "Supplier", sortable: true, width: "10%" },
      { key: "Description", label: "Description", visibleMode: "d-none-xs", sortable: true },
      { key: "Total", label: "Total", sortable: true, width: "10%" },
      { key: "PaymentDueDate", label: "Payment Due Date", visibleMode: "d-none-xs", sortable: true, width: "18%" },
      { key: "DateExpected", label: "Date Expected", visibleMode: "d-none-xs", sortable: true, width: "15%" },
      { key: "Status", label: "Status", sortable: true, width: "10%" },
      { key: "EditIcons", label: "Edit", visibleMode: "d-none-xs" },
      { key: "DeleteIcon", label: "Delete (In 7 days)", visibleMode: "d-none-xs" }
    ],
    tableColumnsDialogTransfer: [
      { key: "ID", label: "PO#", sortable: true },
      { key: "Description", label: "Description", visibleMode: "d-none-xs", sortable: true },
      { key: "Total", label: "Total", sortable: true },
      { key: "View", label: "", sortable: true },
      { key: "Icons", label: "", visibleMode: "d-none-xs" }
    ],
    filters: {
      po: { label: "PO#", hintText: "PO#" },
      dueDate: { label: "Payment Due Date", hintText: "Payment Due Date" },
      dateExpected: { label: "Date Expected", hintText: "Date Expected" },
      filterButton: "Search",
      cleanFilterButton: "Clean"
    },
    dashBoardTable: [
      { key: "ID", label: "PO#" },
      { key: "Total", label: "Total" },
      { key: "DateExpected", label: "Date Expected" }
    ],
    productPurchaseOrderColumns: [
      { key: "ID", label: "PO#" },
      { key: "Description", label: "Description", visibleMode: "d-none-xs" },
      { key: "Total", label: "Total" },
      { key: "PaymentDueDate", label: "Payment Due" },
      { key: "DateExpected", label: "Date Expected", visibleMode: "d-none-xs" },
      { key: "CreatedDate", label: "Created Date", visibleMode: "d-none-xs" },
      { key: "Status", label: "Status", visibleMode: "d-none-xs" }
    ],
    tableColumnsProduct: [
      { key: "SKU", label: "PRODUCTS" }
    ],
    controls: {
      saveButton: "Save",
      cancelButton: "Cancel",
      editButton: "Edit",
      removeProduct: "Remove"
    },
    titles: {
      add: "Add New Purchase Order",
      edit: "Edit Purchase Order"
    }
  },
  transferProduct: {
    warehouse: { label: "Warehouse", hintText: "Warehouse" },
    inventoryAdjust: { label: "Product Hub", hintText: "Inventory Adjust" },
    amount: { label: "Amount", hintText: "Amount" },
    transferProductSuccess: "Your product was transferred to the Warehouse successfully.",
    adjustProductSuccess: "Your product quantity was adjusted successfully.",
    adjustProductError: "An error occurred while adjusting the product's quantity, please try again. If the error persists, please contact the administrator.",
    WpSyncError: "Could Not Sync all product inventories.",
    mergeProductSuccess: "Your product was merged to the Joint/ PRE-ROLL product successfully.",
    transferProductError: "An error occurred while transfering the product to the Warehouse, please try again. If the error persists, please contact the administrator.",
    receiveProductSuccess: "Your product was transferred to the Storage Warehouse successfully.",
    receiveProductError: "An error occurred while transfering the product to the Storage Warehouse, please try again. If the error persists, please contact the administrator.",
    mergeProductError: "An error occurred while merging the products to the Joint/ PRE-ROLL product, please try again. If the error persists, please contact the administrator.",
    tableColumnsProductPO: [
      { key: "Information", label: "Product Information", width: "50%" },
      { key: "Quantity", label: "Quantity" },
      { key: "ReceiveIcon", label: "", width: "120px" }
    ],
    tableColumnsWarehouse: [
      { key: "SKU", label: "SKU" },
      { key: "Name", label: "Name" },
      { key: "TypeCategory", label: "Type & Category", visibleMode: "visible-lg" },
      { key: "Quantity", label: "Quantity", visibleMode: "visible-lg" },
      { key: "Amount", label: "Amount" },
      { key: "ToWarehouse", label: "To Warehouse" },
      { key: "TransferIcon", label: "Transfer" }
    ],
    tableColumnsWarehouseSell: [
      { key: "SKU", label: "SKU" },
      { key: "Name", label: "Name" },
      { key: "TypeCategory", label: "Type & Category", visibleMode: "visible-lg" },
      { key: "Quantity", label: "Quantity", visibleMode: "visible-lg" },
      { key: "Amount", label: "Amount" },
      { key: "ToWarehouse", label: "To Warehouse" },
      { key: "TransferIcon", label: "Transfer" },
      { key: "AdjustIcon", label: "Adjust" }
    ],
    tableColumnsWarehouseStock: [
      { key: "SKU", label: "SKU" },
      { key: "Name", label: "Name" },
      { key: "TypeCategory", label: "Type & Category", visibleMode: "visible-lg" },
      { key: "Quantity", label: "Quantity", visibleMode: "visible-lg" },
      { key: "Amount", label: "Amount" },
      { key: "ToWarehouse", label: "To Warehouse" },
      { key: "TransferIcon", label: "Transfer" },
      { key: "AdjustIcon", label: "Adjust" },
      { key: "JointIcon", label: "Joint" }
    ],
    tableColumnsProductJoint: [
      { key: "ID", label: "ID" },
      { key: "Name", label: "Name", visibleMode: "visible-lg" },
      { key: "Quantity", label: "Quantity", visibleMode: "visible-lg" },
      { key: "Amount", label: "Units to Transfer" }
    ],
    tableColumnsWarehouseALL: [
      { key: "SKU", label: "SKU", visibleMode: "d-none-xs" },
      { key: "Name", label: "Name" },
      { key: "TypeCategory", label: "Type & Category", visibleMode: "d-none-xs" },
      { key: "Quantity", label: "Quantity", visibleMode: "d-none-xs" },
      { key: "Warehouse", label: "Warehouse" },
      { key: "Amount", label: "Amount" },
      { key: "ToWarehouse", label: "Transfer To" },
      { key: "TransferIcon", label: "Transfer" },
      { key: "Adjust", label: "Adjust" },
      { key: "Joint", label: "Joint" }
    ],
    tableColumnsWarehouseCard: [
      { key: "ProductInfo", label: "PRODUCTS", visibleMode: "text-center" }
    ],
    tableColumnsWarehouseTransfer: [
      { key: "warehouseType", label: "Warehouse Type", visibleMode: "d-none-xs", sortable: false },
      { key: "packageReference", label: "Package Reference", sortable: false },
      { key: "quantity", label: "Expected Quantity", sortable: false },
      { key: "pendingTransfer", label: "Pending Outward Transfer", sortable: false }
    ],
    tableColumnsBulkTransfer: [
      { key: "warehouseType", label: "Warehouse Type", visibleMode: "d-none-xs", sortable: false }
    ],
    tableColumnsTransferFrom: [
      { key: "SKU", label: "SKU", visibleMode: "d-none-xs" },
      { key: "Name", label: "Name" },
      { key: "Quantity", label: "Quantity" },
      { key: "TransferIcon", label: "" }
    ],
    tableColumnsTransferTo: [
      { key: "SKU", label: "SKU", visibleMode: "d-none-xs" },
      { key: "Name", label: "Name" },
      { key: "Amount", label: "Ammount" },
      { key: "CancelIcon", label: "" }
    ],
    controls: {
      saveButton: "Save",
      cancelButton: "Cancel",
      editButton: "Edit"
    },
    transferProductReasons: {
      all: [{
        text: "Transfer",
        value: "1",
        description: "Regular transfer between warehouses"
      }
        , {
        text: "Purchased",
        value: "2",
        description: "Products purchased via purchase order"
      }
        , {
        text: "Sale",
        value: "3",
        description: "Regular sale to retail customers"
      }
        , {
        text: "Returned From Customer",
        value: "4",
        description: "Returned by retail customers to a retail store"
      }
        , {
        text: "Destroyed",
        value: "5",
        description: "Destroyed on the premise of a cannabis retail establishment and does not include product sent back to the distributor for destruction"
      }
        , {
        text: "Addition",
        value: "6",
        description: "Any addition to a retail store’s inventory above what they purchased (example: over shipment)"
      }
        , {
        text: "Lost",
        value: "7",
        description: "Any quantity that is subject to criminal theft or is lost"
      }
        , {
        text: "Returned To Distributor",
        value: "8",
        description: "Product returned to the distributor by a cannabis retail establishment"
      }
        , {
        text: "Other Reduction",
        value: "9",
        description: "A given product which are no longer accounted for by a cannabis retail establishment due to unforeseen reasons"
      }
      ],
      forAdjustment: [{
        text: "Destroyed / Damaged",
        value: "5",
        description: "Destroyed on the premise of a cannabis retail establishment and does not include product sent back to the distributor for destruction"
      }, {
        text: "Lost / Theft",
        value: "7",
        description: "Any quantity that is subject to criminal theft or is lost"
      }
        , {
        text: "Returned To Distributor",
        value: "8",
        description: "Product returned to the distributor by a cannabis retail establishment"
      }
        , {
        text: "Other Reduction",
        value: "9",
        description: "A given product which are no longer accounted for by a cannabis retail establishment due to unforeseen reasons"
      }
      ],
      ocsOtherAdjustmentReasons: [
        {
          text: "Physical Inventory Count (Operationally Initiated)",
          value: "Physical Inventory Count (Operationally Initiated)",
        },
        {
          text: "Physical Inventory Count (AGCO Initiated)",
          value: "Physical Inventory Count (AGCO Initiated)",
        },
        {
          text: "Data Entry Error",
          value: "Data Entry Error",
        },
        {
          text: "Sold Product Handling Error",
          value: "Sold Product Handling Error",
        },
        {
          text: "Receiving Error",
          value: "Receiving Error",
        },
        {
          text: "Cycle Count",
          value: "Cycle Count",
        },
        {
          text: "Internal Audit",
          value: "Internal Audit",
        }
      ],
      warehouseTypeItems: [
        {
          text: 'Storage',
          value: 1
        },
        {
          text: 'Sell',
          value: 2
        },
        {
          text: 'Damage',
          value: 3
        }
      ]
    },
    BulkToUnitWeightOptions: [
      {
        text: "0.5G", value: "0.5"
      },
      {
        text: "1G", value: "1"
      },
      {
        text: "3.5G", value: "3.5"
      },
      {
        text: "5G", value: "5"
      },
      {
        text: "7G", value: "7"
      },
      {
        text: "14G", value: "14"
      },
      {
        text: "28G", value: "28"
      }
    ]
  },
  medicalInformation: {
    doctor: { label: "Doctor", hintText: "Doctor" },
    notes: { label: "Notes", hintText: "Notes" },
    label: "Medical Information"
  },
  patient: {
    listTitle: "Member List",
    viewTitle: "Member View",
    createdMessage: "Member created successfully.",
    editedMessage: "Member information updated successfully.",
    saveErrorMessage: "An error occurred when saving the member's information, please try again. If the error persists, please contact the administrator.",
    underAgeErrorMessage: "This member is under age, you can not save it.",
    overAgeErrorMessage: "Please enter a valid age.",
    patientNumber: "Member Number",
    medical: "Medical",
    id: { label: "ID Number", hintText: "ID Number" },
    firstname: { label: "First Name", hintText: "First Name" },
    lastname: { label: "Last Name", hintText: "Last Name" },
    preferredName: { label: "Preferred Name", hintText: "Preferred Name" },
    cardNumber: { label: "Card Number", hintText: "Card Number" },
    caregiver: { label: "Care Giver", hintText: "Care Giver" },
    phone: { label: "Mobile Phone", hintText: "Mobile Phone" },
    email: { label: "Email", hintText: "Email" },
    additionalInformation: { label: "Additional Information", hintText: "Additional Information" },
    birthdate: { label: "Date of Birth", hintText: "Date of Birth" },
    memberSince: { label: "Member Since Date", hintText: "Member Since Date" },
    expiration: { label: "Expiration Date", hintText: "Expiration Date" },
    idType: { label: "Identification", hintText: "Identification" },
    membershipType: { label: "Membership Type", hintText: "Membership Type" },
    idNumber: { label: "Identification Number", hintText: "Identification Number" },
    address: { label: "Address", hintText: "Address" },
    zip: { label: "Postal Code", hintText: "Postal Code" },
    city: { label: "City", hintText: "City" },
    contactMethod: {
      email: { text: "E-mail", value: "Email" },
      phone: { text: "Phone", value: "Phone" },
      sms: { text: "SMS", value: "SMS" }
    },
    password: { label: "Password", hintText: "********" },
    maxAge: 120,
    springBig: {
      allow: { text: "Receive Communications from Spring Big", value: "Receive Communications from Spring Big" }
    },
    alpineIQ: {
      allow: { text: "Receive Communications from Alpine IQ", value: "Receive Communications from Alpine IQ" }
    },
    tableColumns: [
      { key: "Id", label: "ID", visibleMode: "d-none-sm", sortable: true, width: "120px" },
      { key: "FullName", label: "Full Name", sortable: true },
      { key: "RewardPoints", label: "Reward Points", sortable: true, visibleMode: "d-none-xs" },
      { key: "PointsValue", label: "Points Value", visibleMode: "d-none-xs" },
      { key: "VisitCount", label: "Visit Count", visibleMode: "d-none-xs" },
      { key: "Status", label: "Status", visibleMode: "d-none-xs" },
      { key: "Checkin", label: "" },
      { key: "Icons", label: "", width: "100px" }
    ],
    tableColumnsNoRewards: [
      { key: "Id", label: "ID", visibleMode: "d-none-sm", sortable: true, width: "120px" },
      { key: "FullName", label: "Full Name", sortable: true },
      { key: "Status", label: "Status", visibleMode: "d-none-xs" },
      { key: "Checkin", label: "" },
      { key: "Icons", label: "", width: "100px" }
    ],
    dashBoardTable: [
      { key: "Name", label: "Name" },
      { key: "Points", label: "Points" }
    ],
    controls: {
      addNewButton: "Add New Member",
      saveButton: "Save",
      editButton: "Edit",
      viewButton: "View",
      saveAllButton: "Save Changes",
      roundPrices: "Round All Prices"
    },
    titles: {
      list: "Members",
      add: "Add New Member",
      edit: "Edit Member"
    },
    dialogMemberMerge: {
      memberMain: "Main Member ID",
      memberMerge: "Merge Member ID"

    },
    filters: {
      firstName: { label: "First Name", hintText: "First Name" },
      lastName: { label: "Last Name", hintText: "Last Name" },
      memberNumber: { label: "Member ID", hintText: "Member ID" },
      cardNumber: { label: "Card Number", hintText: "Card Number" },
      careGiver: { label: "Care Giver", hintText: "Care Giver" },
      phoneNumber: { label: "Phone Number", hintText: "Phone Number" },
      email: { label: "Email", hintText: "Email" },
      filterButton: "Search",
      cleanFilterButton: "Clean"
    },
    pointHistory: {
      rewardPoint: { label: "Point Amount", hintText: "Enter the number", name: "PointAmount" },
      comment: { label: "Comment", hintText: "Comment", name: "RewardPointComment" },
      tableColumns: [
        { key: "Date", label: "Date" },
        { key: "Point", label: "Point Amount" },
        { key: "Comment", label: "Comment" }
      ],
      savePoint: { label: "Save" }
    },
    patientRewardOption: [
      { text: "Add", value: "Add" },
      { text: "Remove ", value: "Remove" }
    ],
    patientReward: {
      label: "Add / Remove"
    }
  },
  doctor: {
    addNewButton: "Add new Doctor",
    listTitle: "Doctors",
    viewTitle: "Doctor View",
    createdMessage: "Doctor created successfully.",
    editedMessage: "Doctor edited successfully.",
    saveErrorMessage: "An error occurred when saving the doctor's information, please try again. If the error persists, please contact the administrator.",
    id: { label: "ID Number", hintText: "ID Number" },
    firstname: { label: "First Name", hintText: "First Name" },
    lastname: { label: "Last Name", hintText: "Last Name" },
    license: { label: "License #", hintText: "License #" },
    phone: { label: "Phone", hintText: "Phone" },
    clinic: { label: "Clinic", hintText: "Clinic" },
    address: { label: "Address", hintText: "Address" },
    city: { label: "City", hintText: "City" },
    zip: { label: "Postal Code", hintText: "Postal Code" },
    tableColumns: [
      { key: "ID", label: "#ID", visibleMode: "d-none-sm" },
      { key: "FirstName", label: "Name" },
      // { key: "LastName", label: "Last Name" },
      { key: "Phone", label: "Phone", visibleMode: "d-none-sm" },
      { key: "Status", label: "Status" },
      { key: "Icons", label: "" }
    ],
    controls: {
      saveButton: "Save",
      editButton: "Edit",
      inactivateButton: "Inactivate",
      activateButton: "Activate"
    },
    titles: {
      add: "Add New Doctor",
      edit: "Manage Doctor"
    }
  },
  weight: {
    id: { label: "ID Number", hintText: "ID Number" },
    name: { label: "Name", hintText: "Type weight's setting name" },
    status: { label: "Status", hintText: "Status" },
    weight: { label: "Measurement (g)", hintText: "Type the actual value in grams" },
    maximumWeight: 100000,
    messages: {
      createdMessage: "Weight setting created successfully.",
      editedMessage: "Weight setting edited successfully.",
      saveErrorMessage: "An error occurred when saving the Weight Setting's information, please try again. If the error persists, please contact the administrator."
    },
    controls: {
      addNewButton: "Add New Measurement Setting",
      saveButton: "Save",
      validateExcel: "Validate Excel",
      runschedular: "Run Update"
    },
    tableColumns: [
      { key: "ID", label: "#ID", visibleMode: "d-none-xs" },
      { key: "Name", label: "Name" },
      { key: "Weight", label: "Weight" },
      { key: "Status", label: "Status", visibleMode: "d-none-xs" },
      { key: "Icons", label: "" }
    ]
  },
  priceUpdate: {
    name: { label: "Excel File", hintText: "uploaded Excel file name" },
    scheduleDate: { label: "Start Date", hintText: "Price update start date" },
    startTime: { label: "Start Time", hintText: "Price update start time" },
    status: { label: "Status", hintText: "Status like Open or Close" },
    schedulerStatus: { label: "Schedular Status", hintText: "Status like Open or Close" },
    exceptionTitle: "SKU not found in TechPos",
    deleteTitle: "Delete Schedular",
    deleteMessage: "Are you sure, Do you want to delete?",
    messages: {
      createdMessage: "Update successfully.",
      validatedMessage: "Validated successfully",
      saveErrorMessage: "An error occurred when saving the information, please try again. If the error persists, please contact the administrator."
    },
    controls: {
      addNewButton: "Upload Excel",
      saveButton: "Save"
    },
    tableColumns: [
      { key: "Id", label: "#ID", visibleMode: "d-none-xs" },
      { key: "FileName", label: "File Name" },
      { key: "StartDate", label: "Start Date" },
      { key: "StartTime", label: "Start Time" },
      { key: "Status", label: "Status" },
      { key: "Icons", label: "Action" }
    ],
    tableColumnsException: [
      { key: "RowId", label: "#ID", visibleMode: "d-none-xs" },
      { key: "SKU", label: "SKU" },
      { key: "ProductName", label: "Display Name" },
      { key: "ErrorMesage", label: "Status" }
    ]
  },
  device: {
    id: { label: "ID Number", hintText: "ID Number" },
    name: { label: "Device Name", hintText: "Type device's name" },
    currentipaddress: { label: "Existing IP Address", hintText: "Existing IP Address" },
    pinPadId: { label: "PINPad Id", hintText: "PINPad Id" },
    pinPadIntegrated: { label: "PINPad Integrated", hintText: "PINPad Integrated" },
    ipaddress: { label: "New IP Address", hintText: "New IP Address" },
    status: { label: "Status", hintText: "Status" },
    messages: {
      createdMessage: "Device created successfully.",
      editedMessage: "Device edited successfully.",
      saveErrorMessage: "An error occurred when saving the Device information, please try again. If the error persists, please contact the administrator."
    },
    controls: {
      addNewButton: "Add New Device",
      saveButton: "Save",
      editButton: "Edit"
    },
    tableColumns: [
      // { key: "DeviceNumber", label: "Device Number" },
      { key: "DeviceType", label: "Type" },
      { key: "Role", label: "Role", visibleMode: "d-none-xs" },
      { key: "WorkStation", label: "WorkStation" },
      { key: "IPAddress", label: "IP Address", visibleMode: "d-none-xs" },
      { key: "Status", label: "Status" },
      { key: "Icons", label: "", visibleMode: "d-none-xs" }
    ],
    applicationSettings: {
      saved: "Application Settings saved successfully!",
      error: "Error while saving Application Settings!"
    }
  },
  deviceRoles: {
    name: { label: "Name", hintText: "Type device's role name" },
    description: { label: "Description", hintText: "Type device's role description" },
    status: { label: "Status", hintText: "Status" },
    saveMessage: "Device Role created successfully.",
    saveErrorMessage: "An error occurred when saving the device role information, please try again. If the error persists, please contact the administrator.",
    saveEmptyMessage: "Please fill the Name field to save the new device Role."
  },
  deviceWorkStations: {
    name: { label: "Name", hintText: "Type device's workstation name" },
    description: { label: "Description", hintText: "Type device's workstation description" },
    status: { label: "Status", hintText: "Status" },
    saveMessage: "Device workStation created successfully.",
    saveErrorMessage: "An error occurred when saving the device workstation information, please try again. If the error persists, please contact the administrator.",
    saveEmptyMessage: "Please fill the Name field to save the new device WorkStation.",
    controls: {
      saveButton: "Save",
      cancelButton: "Cancel"
    }
  },
  payment: {
    id: { label: "ID Number", hintText: "ID Number" },
    name: { label: "Name", hintText: "Type payment's name" },
    status: { label: "Status", hintText: "Status" },
    messages: {
      createdMessage: "Payment created successfully.",
      editedMessage: "Payment edited successfully.",
      saveErrorMessage: "An error occurred when saving the payment information, please try again. If the error persists, please contact the administrator."
    },
    controls: {
      addNewButton: "Add New Payment",
      saveButton: "Save",
      editButton: "Edit"
    },
    tableColumns: [
      { key: "Name", label: "Name" },
      { key: "Status", label: "Status" },
      { key: "Icons", label: "", visibleMode: "d-none-xs" }
    ],
    paymentOptions: [
      { text: "Debit", value: "Debit" },
      { text: "Credit", value: "Credit" },
      { text: "Cash", value: "Cash" },
      { text: "Store Credit", value: "StoreCredit" },
      { text: "Gift Card", value: "GiftCard" }
    ]
  },
  taxrate: {
    id: { label: "ID Number", hintText: "ID Number" },
    name: { label: "Name", hintText: "Type tax rate's name" },
    rate: { label: "Tax Rate", hintText: "Type tax rate" },
    status: { label: "Status", hintText: "Status" },
    messages: {
      createdMessage: "Tax Rate created successfully.",
      editedMessage: "Tax Rate edited successfully.",
      saveErrorMessage: "Invalid tax configuration. Please review your tax settings and try again. If the error persists, please contact the administrator."
    },
    controls: {
      addNewButton: "Add New Tax Rate",
      saveButton: "Save",
      editButton: "Edit"
    },
    tableColumns: [
      { key: "ID", label: "#ID", visibleMode: "d-none-xs" },
      { key: "Name", label: "Name" },
      { key: "Rate", label: "Rate" },
      { key: "Status", label: "Status", visibleMode: "d-none-xs" },
      { key: "Icons", label: "", visibleMode: "d-none-xs" }
    ]
  },
  safemanagement: {
    messages: {
      saveErrorMessage: "An error occurred when saving the safe management information, please try again. If the error persists, please contact the administrator.",
      createdMessage: "safe management information added successfully."
    },
    controls: {
      addNewButton: "Add Adjustment",
      saveButton: "Save",
      cancelButton: "Cancel"
    },
    fields: {
      amount: { label: "Amount", hint: "Amount" },
      notes: { label: "Notes", hint: "Notes" },
      types: { label: "Adjustment Type", hint: "Adjustment Type" }
    },
    filters: {
      datefrom: { label: "Date From", hint: "Date From" },
      logUserId: { label: "User", hint: "User" },
      dateto: { label: "Date To", hint: "Date To" },
      type: { label: "Type", hint: "Type" },
      employeeName: { label: "Employee Name", hint: "Employee Name" },
      filterButton: "Search",
      cleanFilterButton: "Clear Filter"
    },
    tableColumns: [
      { key: "date", label: "Date", sortable: false },
      { key: "amount", label: "Amount", sortable: false },
      { key: "adjustment", label: "Adjustment", sortable: false },
      { key: "type", label: "Type", sortable: false },
      { key: "employee", label: "Employee", sortable: false },
      { key: "notes", label: "Notes", sortable: false, width: "20%" }
    ],
    types: [
      { text: "Adjustment +", value: "3" },
      { text: "Adjustment -", value: "4" },
      { text: "Safe Count", value: "2" },
      { text: "Manual add funds", value: "1" }
    ]
  },
  bankdeposits: {
    title: "Bank Deposit",
    messages: {
      saveErrorMessage: "An error occurred when saving the bank deposit information, please try again. If the error persists, please contact the administrator.",
      createdMessage: "Bank Deposit created successfully.",
      editedMessage: "Bank Deposit edited successfully."
    },
    controls: {
      addNewButton: "Add New Bank Deposit",
      saveButton: "Save",
      editButton: "Edit",
      cancelButton: "Cancel"
    },
    fields: {
      id: { label: "ID Number", hint: "ID Number" },
      depositDate: { label: "Deposit Date", hint: "Deposit Date" },
      amount: { label: "Amount", hint: "Amount" },
      coinOrder: { label: "Coin Order", hint: "Coin Order" },
      tips: { label: "Tips", hint: "Tips" },
      referenceCode: { label: "Reference Code", hint: "Reference Code" },
      notes: { label: "Notes", hint: "Notes" },
      userName: { label: "Created by User", hint: "Created by User" }
    },
    filters: {
      depositDate: { label: "Deposit Date", hint: "Deposit Date" },
      startDate: { label: "Start Date", hint: "Start Date" },
      endDate: { label: "End Date", hint: "End Date" },
      amount: { label: "Amount", hint: "Amount" },
      coinOrder: { label: "Coin Order", hint: "Coin Order" },
      tips: { label: "Tips", hint: "Tips" },
      logUserId: { label: "User", hint: "User" },
      referenceCode: { label: "Reference Code", hint: "Reference Code" },
      branch: { label: "Branch", hint: "Branch" },
      filterButton: "Search",
      cleanFilterButton: "Clear Filter"
    },
    tableColumns: [
      { key: "depositDate", label: "Deposit Date", sortable: true },
      { key: "employeeId", label: "Employee Id" },
      { key: "employeeName", label: "Employee Name" },
      { key: "amount", label: "Amount", sortable: true },
      { key: "coinOrder", label: "Coin Order" },
      { key: "tips", label: "Tips"},
      { key: "referenceCode", label: "Reference Code", sortable: true },
      { key: "cashSales", label: "Cash Sales" },
      { key: "cashVariance", label: "Cash Variance" },
      { key: "icons", label: "", width: "80px" }
    ]
  },
  cashregister: {
    name: { label: "Name", hintText: "Type register's name" },
    ipaddress: { label: "IP Address", hintText: "Type register's IP Address" },
    status: { label: "Status", hintText: "Status" },
    messages: {
      verifiedMessage: "The register information was verified successfully.",
      notVerifiedMessage: "The register information was NOT verified successfully.",
      saveErrorMessage: "An error occurred when saving the register information, please try again. If the error persists, please contact the administrator.",
      cashRegistersClosed: "The registers were closed.",
      cashRegistersCloseError: "An error occurred when closing the registers information, please try again. If the error persists, please contact the administrator."
    },
    controls: {
      addNewButton: "Add New Register",
      saveButton: "Save",
      editButton: "Edit",
      cashIn: "Cash In"
    },
    filters: {
      firstName: { label: "First Name", hintText: "First Name" },
      lastName: { label: "Last Name", hintText: "Last Name" },
      clockIn: { label: "Date", hintText: "Date" },
      station: { label: "Station #", hintText: "Station #" },
      filterButton: "Search",
      cleanFilterButton: "Clear Filter"
    },
    tableColumns: [
      { key: "EmployeeFirstName", label: "Full Name", visibleMode: "visible-lg", sortable: true, width: "" },
      { key: "CashInDate", label: "Date", visibleMode: "visible-lg", sortable: true },
      { key: "Station", label: "Station #", sortable: true },
      { key: "Balance", label: "Actual Balance", sortable: true, width: "10%" },
      { key: "ExpectedBalance", label: "Exp. Balance", visibleMode: "visible-lg", width: "10%" },
      { key: "LossBalance", label: "Loss Balance", visibleMode: "visible-lg", width: "10%" },
      { key: "Status", label: "Status", sortable: true },
      { key: "Icons", label: "", visibleMode: "d-none-xs", width: "100px" }
    ],
    todoTableColumns: [
      { key: "Register", label: "Register" },
      { key: "Status", label: "Status" },
      { key: "Icons", label: "" }
    ],
    notesTableColumns: [
      { key: "timestamp", label: "Timestamp", width: "30%" },
      { key: "note", label: "Notes" }
    ]
  },
  shiftList: {
    listTitle: "Shifts",
    filters: {
      firstName: { label: "First Name", hintText: "First Name" },
      lastName: { label: "Last Name", hintText: "Last Name" },
      employee: { label: "Employee", hintText: "Employee" },
      beginDate: { label: "Begin Date", hintText: "Begin Date" },
      endDate: { label: "End Date", hintText: "End Date" },
      filterButton: "Search",
      cleanFilterButton: "Clean"
    },
    tableColumns: [
      { key: "EmployeeFirstName", label: "Full Name", sortable: true },
      { key: "PunchInDate", label: "Date", sortable: true },
      { key: "Status", label: "Status", visibleMode: "d-none-xs", sortable: true },
      { key: "Icon", label: "", width: "120px" }
    ],
    controls: {
      addNewButton: "Add New Shift",
      saveButton: "Save",
      editButton: "Edit",
      viewButton: "View"
    }
  },
  shiftEdit: {
    savedMessage: "Employee's shift saved successfully",
    firstName: { label: "First Name", hintText: "First Name" },
    lastName: { label: "Last Name", hintText: "Last Name" },
    ID: { label: "ID", hintText: "ID" },
    clockIn: { label: "Clock-In", hintText: "8:00:00" },
    clockOut: { label: "Clock-Out", hintText: "17:00:00" },
    date: { label: "Date", hintText: "Date" },
    dateIn: { label: "Date-In", hintText: "Date-In" },
    dateOut: { label: "Date-Out", hintText: "Date-Out" },
    selectTimeSlot: "Select time slot",
    tableColumns: [
      { key: "Number", label: "#" },
      { key: "ClockIn", label: "Clock-In" },
      { key: "ClockOut", label: "Clock-Out" },
      { key: "PaidBreak", label: "Paid Break" },
      { key: "Icon", label: "" }
    ],
    dashBoardTable: [
      { key: "Employee", label: "Name" },
      { key: "ClockIn", label: "Clock-In" },
      { key: "ClockOut", label: "Clock-Out" }
    ]
  },
  openOrders: {
    messages: {
      cancelledMessage: "The order was cancelled successfully.",
      cancelledErrorMessage: "An error occurred while cancelling the order, please try again. If the error persists, please contact the administrator."
    },
    tableColumns: [
      { key: "OrderId", label: "Order #" },
      { key: "Status", label: "Status", visibleMode: "visible-lg" },
      { key: "Date", label: "Date" },
      { key: "Register", label: "Register" },
      { key: "Employee", label: "Employee" },
      { key: "Patient", label: "Member" },
      { key: "Total", label: "Total" },
      { key: "AmountPaid", label: "Amount Paid" },
      { key: "NumberProducts", label: "# of Products", visibleMode: "visible-lg" },
      { key: "Icons", label: "Edit" }
    ]
  },
  inventory: {
    dashBoardTable: [
      { key: "Product", label: "Product" },
      { key: "Quantity", label: "Quantity" }
    ]
  },
  employee: {
    listTitle: "Employee List",
    viewTitle: "Employee View",
    id: { label: "ID Number", hintText: "ID Number" },
    firstname: { label: "First Name", hintText: "First Name" },
    lastname: { label: "Last Name", hintText: "Last Name" },
    phone: { label: "Phone", hintText: "Phone" },
    email: { label: "Email", hintText: "Email" },
    birthdate: { label: "Date of Birth", hintText: "Date of Birth" },
    address: { label: "Address", hintText: "Address" },
    zip: { label: "Postal Code", hintText: "Postal Code" },
    city: { label: "City", hintText: "City" },
    role: { label: "Role", hintText: "Role" },
    SIN: { label: "SIN", hintText: "SIN" },
    TaxClaim: { label: "Tax Claim", hintText: "Tax Claim" },
    QualificationEndDate: { label: "Qualification End Date", hintText: "Qualification End Date" },
    HiredDate: { label: "Hired Date", hintText: "Hired Date" },
    HourlyRate: { label: "Hourly Rate", hitText: "Hourly Rate" },
    createdMessage: "Employee created successfully.",
    editedMessage: "Employee edited successfully.",
    saveErrorMessage: "An error occurred when saving the employees's information, please try again. If the error persists, please contact the administrator.",
    invalidAgeErrorMessage: "This employee is under age, you can not save it.",
    tableColumns: [
      { key: "Id", label: "#ID", visibleMode: "d-none-xs", sortable: true, width: "120px" },
      { key: "FirstName", label: "Full Name", sortable: true },
      // { key: "LastName", label: "Last Name" },
      // { key: "Birthdate", label: "Birth Date", visibleMode: "visible-lg" },
      { key: "Role", label: "Role", sortable: true },
      { key: "Status", label: "Status", visibleMode: "d-none-xs" },
      { key: "EditIcon", label: "Edit", width: "120px" }
      // { key: "ResetPasswordIcon", label: "" }
    ],
    dashBoardTable: [
      { key: "Name", label: "Name" },
      { key: "Sold", label: "Total Sales" }
    ],
    controls: {
      addNewButton: "Add New Employee",
      saveButton: "Save",
      editButton: "Edit"
    },
    titles: {
      list: "Employee",
      add: "Add New Employee",
      edit: "Manage Employee"
    },
    filters: {
      firstName: { label: "First Name", hintText: "First Name" },
      lastName: { label: "Last Name", hintText: "Last Name" },
      role: { label: "Role", hintText: "Role" },
      filterButton: "Search",
      cleanFilterButton: "Clean"
    }
  },
  campaign: {
    name: { label: "Campaign Name", hintText: "Campaign Name" },
    description: { label: "Campaign description", hintText: "Campaign description" },
    tableColumns: [
      { key: "Name", label: "Name", width: "" },
      { key: "Period", label: "Period", visibleMode: "d-none-sm", width: "15%" },
      { key: "WeekDays", label: "WeekDays", visibleMode: "d-none-sm", width: "15%" },
      { key: "Type", label: "Type", visibleMode: "d-none-sm", width: "10%" },
      { key: "Discount", label: "Discount", width: "10%" },
      { key: "Status", label: "Status", visibleMode: "d-none-sm", width: "10%" },
      { key: "EditIcons", label: "Edit", width: "80px" },
      { key: "DeleteIcons", label: "Delete", width: "80px" }
    ],
    productCampaignColumns: [
      { key: "Name", label: "Name" },
      { key: "Period", label: "Period" },
      { key: "WeekDays", label: "WeekDays", visibleMode: "d-none-sm" },
      { key: "Type", label: "Type", visibleMode: "d-none-sm" },
      { key: "Discount", label: "Discount" },
      { key: "Status", label: "Status", visibleMode: "d-none-sm" }
    ],
    productDialogTableColumns: [
      { key: "sku", label: "SKU" },
      { key: "name", label: "Name" },
      { key: "typeCategory", label: "Type and Category" },
      { key: "price", label: "Price" },
      { key: "icons", label: "Add" }
    ],
    categoryAddedTableColumns: [
      { key: "name", label: "Category Name" },
      { key: "icons", label: "" }
    ],
    campaignAddedTableColumns: [
      { key: "name", label: "Campaign Name" },
      { key: "icons", label: "" }
    ],
    productGroupAddedTableColumns: [
      { key: "name", label: "Product Name" },
      { key: "category", label: "Category" },
      { key: "type", label: "Type" },
      { key: "icons", label: "" }
    ],
    productAddedTableColumns: [
      { key: "sku", label: "SKU" },
      { key: "name", label: "Product Name" },
      { key: "icons", label: "" }
    ],
    controls: {
      addNewButton: "Add New Campaign",
      exportCSV: "Export CSV",
      toggleExportCSV: "Include Inactive Campaign",
      saveButon: "Save",
      editButton: "Edit",
      addProductToCampaign: "Add to Campaign"
    },
    titles: {
      list: "Campaign",
      add: "Add New Campaign",
      edit: "Manage Campaigns"
    },
    campaignType: [
      { text: "Recurrent Sale", value: "1" },
      { text: "One Time Sale", value: "2" }
    ],
    status: "Status",
    applyForMembersOnly: "Apply for Members Only",
    applyOnlineOnly: "Apply Online Only",
    applyInStoreOnly: "Apply In-Store Only",
    startDate: { label: "Start Date", hintText: "Start Date" },
    endDate: { label: "End Date", hintText: "End Date" },
    startTime: { label: "Start Time", hintText: "Start Time" },
    endTime: { label: "End Time", hintText: "End Time" },
    day: [
      { name: "Mon", text: "Monday", value: "1" },
      { name: "Tue", text: "Tuesday", value: "2" },
      { name: "Wed", text: "Wednesday", value: "3" },
      { name: "Thu", text: "Thursday", value: "4" },
      { name: "Fri", text: "Friday", value: "5" },
      { name: "Sat", text: "Saturday", value: "6" },
      { name: "Sun", text: "Sunday", value: "0" }
    ],
    discountType: [
      { text: "Percentage", value: "1" },
      { text: "Amount", value: "2" }
    ],
    value: { label: "Discount Value", hintText: "Value" },
    filters: {
      productName: { label: "Search By Product's Name", hintText: "Product's Name" },
      productSku: { label: "Search By Product's SKU", hintText: "Product's SKU" },
      brand: { label: "Search By Brand", hintText: "Product's Brand" },
      po: { label: "Search By PO #", hintText: "Search By PO #" },
    },
    messages: {
      createdMessage: "Campaign created successfully.",
      editedMessage: "Campaign edited successfully.",
      saveErrorMessage: "An error occurred when saving the Campaign's information, please try again. If the error persists, please contact the administrator."
    }
  },
  combo: {
    name: { label: "Combo Name", hintText: "Combo Name" },
    price: { label: "Price", hintText: "Price" },
    quantity: { label: "Quantity", hintText: "Quantity" },
    tableColumns: [
      { key: "Name", label: "Name" },
      { key: "Price", label: "Price" },
      { key: "Status", label: "Status", visibleMode: "d-none-sm" },
      { key: "EditIcon", label: "Edit" },
      { key: "DeleteIcon", label: "Delete" }
    ],
    controls: {
      addNewButton: "Add New Combo",
      saveButon: "Save",
      editButton: "Edit",
      addProductToCombo: "Add to Combo"
    },
    filters: {
      productName: { label: "Product Name", hintText: "Product Name" },
      productSKU: { label: "Product SKU", hintText: "Product SKU" }
    },
    productDialogTableColumns: [
      { key: "sku", label: "SKU" },
      { key: "name", label: "Name" },
      { key: "typeCategory", label: "Type and Category" },
      { key: "price", label: "Price" },
      { key: "icons", label: "Add" }
    ],
    messages: {
      createdMessage: "Combo created successfully.",
      editedMessage: "Combo edited successfully.",
      saveErrorMessage: "An error occurred when saving the Combo's information, please try again. If the error persists, please contact the administrator."
    },
    productAddedTableColumns: [
      { key: "sku", label: "SKU" },
      { key: "name", label: "Product Name" },
      { key: "quantity", label: "Product Quantity" },
      { key: "icons", label: "" }
    ]
  },
  customizedDiscount: {
    name: { label: "Discount Name", hintText: "Discount Name" },
    status: "Status",
    discoutType: "Type",
    amount: { label: "Value", hintText: "Value" },
    promotionCode: { label: "Promotion Code", hintText: "Promotion Code" },
    minimumAmountToApplyPromotionCode: { label: "Minimum Order Amount To Apply PromotionCode", hintText: "Minimum Order Amount To Apply PromotionCode" },
    isStickyCardDiscount: "StickyCards Discount",
    tableColumns: [
      { key: "Name", label: "Name" },
      { key: "Type", label: "Type" },
      { key: "Value", label: "Value" },
      { key: "Status", label: "Status", visibleMode: "d-none-sm" },
      { key: "EditIcon", label: "", width: "120px" },
      { key: "DeleteIcon", label: "", width: "120px" }

    ],
    controls: {
      addNewButton: "Add New Discount",
      saveButon: "Save",
      editButton: "Edit",
      addProductToCombo: "Add to Discount"
    },
    messages: {
      createdMessage: "Discount created successfully.",
      editedMessage: "Discount edited successfully.",
      saveErrorMessage: "An error occurred when saving the Discount's information, please try again. If the error persists, please contact the administrator."
    }
  },
  integrations: [
    { name: "Global Payments", type: ["Payment Processing"], description: "A globally compatible pay solution to help startups reach success ­and provide an effortless payment experience for customers.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/globalPayments.jpg" },
    { name: "Elavon", type: ["Payment Processing"], description: "Offer your customers a fast and simple checkout experience with a flexible and secure payment solution.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/elavon.jpg" },
    { name: "Paystone Payment", type: ["Payment Processing", "Gift Card"], description: "Offer your customers a fast and simple checkout experience with a flexible and secure payment solution.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/paystone.png" },
    { name: "Moneris", type: ["Payment Processing", "Gift Card"], description: "An all-in-one payment solution for your business. Implement an easy-to-use solution for your retail stores with a reliable and secure pay terminal.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/moneris.jpg" },
    { name: "Merrco", type: ["Payment Processing"], description: "Provide a secure payment system in your cannabis retail store.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/merrco.png" },
    { name: "Birchmount", type: ["Gift Card"], description: "Provide a secure payment system in your cannabis retail store.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/birchmount.png" },
    { name: "CPOS PIC", type: ["Payment Middleware"], description: "A middleware software package that provides businesses with the flexibility to integrate their payment terminal with a point-of-sale system.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/cpos.png" },
    { name: "Paymentree", type: ["Payment Middleware"], description: "Provide a secure payment system in your cannabis retail store.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/paymentree.png" },
    { name: "Dutchie", type: ["E-commerce"], description: "A web platform that will simplify online shopping from your dispensary.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/dutchie.png" },
    { name: "Leafly", type: ["E-commerce"], description: "Access information about all cannabis products.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/leafly.png" },
    { name: "Buddi", type: ["E-commerce"], description: "Offer a Cannabis friendly web-menu with click & collect and delivery options for your Canadian customers.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/buddi.jpg" },
    { name: "Woocommerce", type: ["E-commerce"], description: "Open-source e-commerce plugin for WordPress.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/woocommerce.png" },
    { name: "Alpine IQ", type: ["Marketing and Loyalty Program"], description: "Alpine IQ is a customer data compliance tool providing marketing, loyalty and analytics to core businesses.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/alpineIQ.png" },
    { name: "Spring Big", type: ["Marketing and Loyalty Program"], description: "Spring Big is a leading cannabis marketing platform used to increase retention, boost revenue, build customer loyalty by creating smarter cannabis marketing campaigns.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/springbig.png" },
    { name: "Sticky Cards", type: ["Marketing and Loyalty Program"], description: "Simple cannabis loyalty program to reward customers with the stickiest cannabis loyalty program around.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/stickycards.png" },
    { name: "Weedmaps", type: ["E-commerce"], description: "Weedmaps is a leading cannabis technology platform providing integrated solutions for cannabis consumers and businesses.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/weedmaps.png" },
    { name: "Age Checker", type: ["Secure Online Age Verification"], description: "Age Checker provides an easy checkout experience to match customer information at checkout to confirm identity with networks to verify that a customer meets the minimum age requirements.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/ageChecker.png" },
    { name: "Machool", type: ["Shipping and Delivery"], description: "Machool is a shipping portal to compare real-time shipping rates and streamline shipping processes.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/machool.png" },
    { name: "Store to Door", type: ["Shipping and Delivery"], description: "Store to Door is a universal delivery service providing direct delivery services for all types of businesses to consumers using direct certified drivers.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/storetodoor.png" },
    { name: "Twilio", type: ["Email & SMS Messaging"], description: "Twilio is the industry-leading and trusted non cannabis marketing platform that efficiently powers customer engagement innovation.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/twilio.png" },
    { name: "Canna Collective", type: ["Data Metrics"], description: "Canna Collective uses a collection of cannabis independent retailers to open up opportunities that exists in the cannabis industry.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/cannacollective.png" },
    { name: "Independent Retail Cannabis Collective", type: ["Data Metrics"], description: "The Independent Retail Cannabis Collective is a countrywide initiative designed for independent retailers. It provides access to revenue opportunities, fosters professional growth, and offers education to bolster business vitality and retail longevity.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/ircc.jpg" },
    { name: "Headset", type: ["Data Metrics"], description: "Headset is a source for cannabis market data, networking cannabis dispensaries, producers and industry leaders by delivering insights and analytics.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/headset.svg" },
    { name: "Canna Drop", type: ["Accessory Drop Shipping"], description: "Cannadrop is your one stop shop for accessories through drop shipping.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/cannadrop.png" },
    { name: "UBI Communications", type: ["Digital Signage"], description: "Established in 2001, UBI is a company of experts in digital signage. They have lived through the early development years.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/ubicommunications.jpg" },
    { name: "Budvue", type: ["Digital Signage"], description: "Create a digital menu board for your stores to allow your customers to easily view your cannabis product information.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/budview.png" },
    { name: "BudSense", type: ["Digital Signage"], description: "With BudSense, you can build digital, print, and web cannabis menus.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/budsense.png" },
    { name: "SoLink", type: ["Cloud Video Surveillance"], description: "Solink provides trusted, cloud video surveillance systems for retailers and financial organizations which acts as the hub for business operations, security, and loss prevention strategies for global brands.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/solink.jpg" },
    { name: "QuickBooks", type: ["Accounting Services"], description: "Quickbooks is a one stop financial management tool used to manage books, track expenses and invoice customers.", imgLink: "https://techposdev.blob.core.windows.net/integrationimages/quickbooks.svg" }
  ],
  errors: {
    invalidEmail: "Email address is already registered. Please enter a different email address.",
    invalidPassword: "Passwords must at least eight characters long and include at least one number, one lowercase letter and one capital letter."
  },
  common: {
    genericError: "An error occurred to process your request, please try again. If the error persists, please contact the administrator.",
    confirm: { text: "Confirm" },
    cancel: { text: "Cancel" },
    close: { text: "Close" },
    genders: [
      { text: "Male", value: "Male" },
      { text: "Female", value: "Female" },
      { text: "Gender Non Conforming", value: "NonConforming" },
      { text: "Non binary", value: "NonBinary" }
    ],
    identificationTypes: [
      { text: "Driver's License", value: "DriversLicense" },
      { text: "Status ID", value: "IdentificationCard" },
      { text: "Passport ", value: "Passport" }
    ],
    unitOfMeasurement: [
      { text: "Unit", value: "Unit" },
      { text: "Weight", value: "Weight" }
    ],
    currency: [
      { text: "Canadian dollar($)", value: "CAD" },
      { text: "United States dollar($)", value: "USD" }
    ],
    country: {
      label: "Country", hintText: "Country",
      options: [
        { text: "Canada", value: "CA" },
        { text: "United States", value: "US" }
      ],
      regions: [
        { text: "British Columbia", value: "BC", code: "CA" },
        { text: "Ontario", value: "ON", code: "CA" },
        { text: "Alberta", value: "AB", code: "CA" },
        { text: "Manitoba", value: "MB", code: "CA" },
        { text: "New Brunswick", value: "NB", code: "CA" },
        { text: "Newfoundland and Labrador", value: "NL", code: "CA" },
        { text: "Northwest Territories", value: "NT", code: "CA" },
        { text: "Nova Scotia", value: "NS", code: "CA" },
        { text: "Nunavut", value: "NU", code: "CA" },
        { text: "Prince Edward Island", value: "PE", code: "CA" },
        { text: "Quebec", value: "QC", code: "CA" },
        { text: "Saskatchewan", value: "SK", code: "CA" },
        { text: "Yukon", value: "YT", code: "CA" },
        { text: "Alabama", value: "AL", code: "US" },
        { text: "Alaska", value: "AK", code: "US" },
        { text: "Arizona", value: "AZ", code: "US" },
        { text: "Arkansas", value: "AR", code: "US" },
        { text: "California", value: "CA", code: "US" },
        { text: "Colorado", value: "CO", code: "US" },
        { text: "Connecticut", value: "CT", code: "US" },
        { text: "Delaware", value: "DE", code: "US" },
        { text: "Florida", value: "FL", code: "US" },
        { text: "Georgia", value: "GA", code: "US" },
        { text: "Hawaii", value: "HI", code: "US" },
        { text: "Idaho", value: "ID", code: "US" },
        { text: "Illinois", value: "IL", code: "US" },
        { text: "Indiana", value: "IN", code: "US" },
        { text: "Iowa", value: "IA", code: "US" },
        { text: "Kansas", value: "KS", code: "US" },
        { text: "Kentucky", value: "KY", code: "US" },
        { text: "Louisiana", value: "LA", code: "US" },
        { text: "Maine", value: "ME", code: "US" },
        { text: "Maryland", value: "MD", code: "US" },
        { text: "Massachusetts", value: "MA", code: "US" },
        { text: "Michigan", value: "MI", code: "US" },
        { text: "Minnesota", value: "MN", code: "US" },
        { text: "Mississippi", value: "MS", code: "US" },
        { text: "Missouri", value: "MO", code: "US" },
        { text: "Montana", value: "MT", code: "US" },
        { text: "Nebraska", value: "NE", code: "US" },
        { text: "Nevada", value: "NV", code: "US" },
        { text: "New Hampshire", value: "NH", code: "US" },
        { text: "New Jersey", value: "NJ", code: "US" },
        { text: "New Mexico", value: "NM", code: "US" },
        { text: "New York", value: "NY", code: "US" },
        { text: "North Carolina", value: "NC", code: "US" },
        { text: "North Dakota", value: "ND", code: "US" },
        { text: "Ohio", value: "OH", code: "US" },
        { text: "Oklahoma", value: "OK", code: "US" },
        { text: "Oregon", value: "OR", code: "US" },
        { text: "Pennsylvania", value: "PA", code: "US" },
        { text: "Rhode Island", value: "RI", code: "US" },
        { text: "South Carolina", value: "SC", code: "US" },
        { text: "South Dakota", value: "SD", code: "US" },
        { text: "Tennessee", value: "TN", code: "US" },
        { text: "Texas", value: "TX", code: "US" },
        { text: "Utag", value: "UT", code: "US" },
        { text: "Vermont", value: "VT", code: "US" },
        { text: "Virginia", value: "VA", code: "US" },
        { text: "Washington", value: "WA", code: "US" },
        { text: "West Virginia", value: "WV", code: "US" },
        { text: "Wisconsin", value: "WI", code: "US" },
        { text: "Wyoming", value: "WY", code: "US" }
      ]
    },
    state: { label: "Province/State", hintText: "Province/State" }
  },
  components: {
    webcamCapture: {
      visualize: "Vizualize",
      capture: "Capture Photo",
      dialogCaptureTitle: "Capturing Photo",
      dialogVisualizeTitle: "Visualize Photo"
    }
  },
  report: {
    text: "Reports",
    link: "/report",
    common: {
      branch: "Branch",
      branchName: "BranchOption",
      branchOption: [
        { text: "TechPOS - Retail", value: "1" },
        { text: "TechPOS - Medical", value: "2" }
      ],
      month: "Month",
      monthName: "MonthOption",
      monthOption: [
        { text: "January", value: "1" },
        { text: "February", value: "2" },
        { text: "March", value: "3" },
        { text: "April", value: "4" },
        { text: "May", value: "5" },
        { text: "June", value: "6" },
        { text: "July", value: "7" },
        { text: "August", value: "8" },
        { text: "September", value: "9" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" }
      ],
      MBInventoryAdjustMonth: [
        { text: "January to March", value: "1" },
        { text: "April to June", value: "4" },
        { text: "July to September", value: "7" },
        { text: "October to December", value: "10" },
      ],
      status: "Status",
      statusOption: [
        { text: "All", value: "0" },
        { text: "Opened", value: "1" },
        { text: "Completed", value: "2" },
        { text: "Cancelled", value: "3" },
        { text: "Returned", value: "4" },
        { text: "Returned Partial", value: "5" }
      ],
      statusTimesheetOption: [
        { text: "All", value: "0" },
        { text: "Pending", value: "1" },
        { text: "Approved", value: "2" },
        { text: "Disapproved", value: "3" }
      ],
      approvalType: "ApprovalType",
      approvalTypeLabel: "Approval Type",
      approvalOptions: [
        { text: "All", value: "0" },
        { text: "Cancel", value: "1" },
        { text: "Refund", value: "2" },
        { text: "Order Discount", value: "3" },
        { text: "Product Discount", value: "4" }

      ],
      categoty: "Category",
      subcategory: { label: "Sub Category", name: "Sub Category" },
      subcategory: "SubCategory",
      categoryName: "CategoryOption",
      beginDate: { label: "Begin Date", name: "BeginDate" },
      endDate: { label: "End Date", name: "EndDate" },
      fromDate: { label: "From Date", name: "FromDate" },
      toDate: { label: "To Date", name: "ToDate" },
      selectedDate: { label: "Selected Date", name: "SelectedDate" },
      dateRangeError: "Begin date must be before End date",
      dateRangeLimitError: "Due to the volumn of data required for this report, we currently only support a maximum of 31 days of data. Please contact support if you would like to download the report for a longer date range.",
      downloadReport: { label: "Download CSV", name: "downloadcsv" },
      downloadProductList: { label: "Export to .xlsx", name: "Export to .xlsx" },
      brandNameError: "number of letters entered for Brand is at least 3.",
      ClearFilter: { label: "Clear Filter", name: "clearFilter" },
      viewReport: { label: "View Report", name: "ViewReport" },
      reportAutomation: { label: "Report Automation", name: "reportAutomation" },
      exportExcel: { label: "Export Excel", name: "ExportExcel" },
      print: { label: "Print", name: "Print" },
      employeeName: { label: "Employee Name", name: "EmployeeName" },
      employeeFirstName: { label: "Employee First Name", name: "EmployeeFirstName" },
      employeeLastName: { label: "Employee Last Name", name: "EmployeeLastName" },
      employeeNumber: { label: "Employee #", name: "EmployeeNumber" },
      warehouse: { label: "Warehouse", name: "Warehouse" },
      vendor: { label: "Vendor", name: "Vendor" },
      orderType: { label: "Order Type", name: "OrderType" },
      warehouseOption: [
        { text: "All", value: "0" },
        { text: "Storage - Retail", value: "1" },
        { text: "Store - Retail", value: "2" },
        { text: "Damage - Retail", value: "3" },
        { text: "Storage - Medical", value: "4" },
        { text: "Store - Medical", value: "5" },
        { text: "Damage - Medical", value: "6" }
      ],
      reportCategory: {
        MANAGEMENTEREPORTS: "MANAGEMENT REPORTS",
        SALESREPORTS: "SALES REPORTS",
        EMPLOYEE: "EMPLOYEE",
        CASHMANAGEMENT: "CASH MANAGEMENT",
        INVENTORY: "INVENTORY",
        CONSOLIDATEDREPORT: "CONSOLIDATED REPORTS",
        CUSTOMERS: "MEMBERS",
        COMPLIANCE: "COMPLIANCE",
        TAX: "TAX"
      }
    },
    annualSales: {
      id: 1,
      isReport: 1,
      removed: 1,
      category: "SALES REPORTS",
      text: "Annual Sales Summary",
      description: "Annual Sales Summary summarizes the current year's sales with the current year's number of orders, total revenue, and average per order.",
      year: { label: "Year", name: "Year" },
      link: "/report/annual-sales"
    },
    budtenderAvgSales: {
      id: 2,
      isReport: 1,
      category: "EMPLOYEE",
      text: "Budtender Average Sales",
      description: "This report lists all employees of the selected branch and displays their detailed sales performance.",
      link: "/report/budtender-average-sales"
    },
    dailyCashSummary: {
      id: 3,
      isReport: 1,
      category: "CASH MANAGEMENT",
      text: "Daily Cash Flow Summary",
      description: "The Daily Cash Flow Summary report displays the daily number of orders, dollar amounts for the daily sales, cash refunds, cash-in and cash-out amounts.",
      link: "/report/daily-cash-summary"
    },
    revenueReport: {
      id: 4,
      isReport: 1,
      category: "INVENTORY",
      text: "Inventory Planner & Revenue Report",
      description: "This report details the products, their inventory status, quantity ordered, and quantity sold.",
      link: "/report/revenue-report"
    },
    transactionSummary: {
      id: 5,
      isReport: 1,
      removed: 1,
      category: "SALES REPORTS",
      text: "Transaction Count Summary",
      description: "The Transaction Count Summary report shows an overview of all transactions.",
      link: "/report/transaction-summary"
    },
    creditPayments: {
      id: 6,
      isReport: 1,
      category: "CASH MANAGEMENT",
      text: "Payment Report",
      description: "The Payments report shows a total summary of daily/monthly payment types.",
      link: "/report/credit-payments"
    },
    giftCardBalance: {
      id: 66,
      isReport: 1,
      category: "CASH MANAGEMENT",
      text: "Gift Card Balance",
      description: "Gift Card Balance report shows a summary and daily total of various types of credit cards sales.",
      link: "/report/gift-card-balance"
    },
    salesBytype: {
      id: 7,
      isReport: 1,
      removed: 1,
      category: "SALES REPORTS",
      text: "Daily Sales By Type",
      description: "Daily Sales by Type reports details of the daily sales by cannabis vs non-cannabis sales and their total taxes.",
      link: "/report/sales-by-type"
    },
    profitReport: {
      id: 8,
      isReport: 1,
      removed: 1,
      category: "SALES REPORTS",
      text: "Profit Report",
      description: "The Profit Report includes the total number of products sold per day along with profit, sales and costs.",
      link: "/report/profit-report"
    },
    manualInventoryChange: {
      id: 9,
      isReport: 1,
      category: "INVENTORY",
      text: "Manual Inventory Change",
      description: "This report lists all the manual changes made to the inventory.",
      link: "/report/manual-inventory-change"
    },
    inventoryLevel: {
      id: 10,
      isReport: 1,
      category: "INVENTORY",
      text: "Product Velocity",
      description: "Product Velocity report visually demonstrates how many units per branch are sold.",
      link: "/report/inventory-level"
    },
    endOfDay: {
      id: 11,
      isReport: 1,
      category: "CONSOLIDATED REPORTS",
      text: "End of Day Report",
      description: "End of Day report details all the necessary data for the end of the day including total sales per category of product and employee performance summaries for the day.",
      link: "/report/endofday"
    },

    categorysales: {
      id: 12,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Sales by Category",
      description: "Sales by Category shows the total Gross Sales, Net Sales, Discounts, Refunds, Costs, and current quantity for each category and products.",
      link: "/report/category-sales"
    },
    productSales: {
      id: 13,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Product Sales",
      description: "Product Sales reports lists each product's sales details including quantity of item sold, base price, profit margin, selling price, and gross sales.",
      link: "/report/product-sales",
    },
    reorderReport: {
      id: 14,
      isReport: 1,
      category: "INVENTORY",
      text: "Inventory Trend by Sale (Re-Order Report)",
      description: "This report helps you determine re-order quantity of each product.",
      link: "/report/reorder-report"
    },
    taxSummary: {
      id: 15,
      isReport: 1,
      removed: 1,
      category: "TAX",
      text: "Tax Summary",
      description: "This report displays the detailed tax dollar amount.",
      link: "/report/tax-summary"
    },
    generalReport: {
      id: 16,
      isReport: 1,
      category: "CONSOLIDATED REPORTS",
      text: "Sigma Report",
      description: "Sigma report details the calculation of COGS (cost of goods sold) and shows its value.",
      link: "/report/sigma-report"
    },
    hourlySales: {
      id: 17,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Hourly Sales",
      description: "Hourly Sales gives you a clear visual representation of the traffic and sales at your location. Use this feature for smarter staffing schedules.",
      link: "/report/hourly-sales"
    },
    purchaseOrderReport: {
      id: 18,
      isReport: 1,
      category: "INVENTORY",
      text: "Purchase Order Report",
      description: "This report summarizes the purchase of inventory costs, vendor, tax, and related fees.",
      link: "/report/purchaseorder-report"
    },
    transactionDetails: {
      id: 19,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Order Details",
      link: "/report/transaction-details"
    },
    destroyedProductReport: {
      id: 20,
      isReport: 1,
      category: "COMPLIANCE",
      text: "Destroyed Product Report",
      description: "This report shows the details of the discard of a product by an employee, and any notes if added.",
      link: "/report/destroyed-product"
    },
    salesSummary: {
      id: 21,
      isReport: 1,
      removed: 1,
      category: "SALES REPORTS",
      text: "Monthly Sales Summary",
      description: "Monthly Sales Summary gives an overview of the number of orders, total revenue, and average dollar amount per order.",
      link: "/report/sales-summary"
    },
    customerSales: {
      id: 22,
      isReport: 1,
      category: "MEMBERS",
      text: "Member Sales", /* Customer Sales Report */
      description: "This report shows customer information and their order details.",
      link: "/report/customer-sales"
    },
    shiftByDay: {
      id: 23,
      isReport: 1,
      category: "EMPLOYEE",
      text: "Shift by Day",
      link: "/report/shift-day"
    },
    discrepancyReport: {
      id: 24,
      isReport: 1,
      category: "COMPLIANCE",
      text: "Manual Inventory Change In Cannabis Products",
      description: "This report details the information about any discrepancies in cannabis products at the branch selected.",
      link: "/report/discrepancy-report"
    },
    shiftByEmployee: {
      id: 25,
      isReport: 1,
      category: "EMPLOYEE",
      text: "Shift by Employee",
      link: "/report/shift-employee",
      empNumber: { label: "Employee Number", name: "Employee Number" }
    },
    monthlyProductSales: {
      id: 26,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Monthly Product Sales",
      description: "Monthly Product Sales shows each product with its assigned SKU number and type, its total sale and the quantity sold of each product as well as total sale amount for the year thus far.",
      year: { label: "Year", name: "Year" },
      link: "/report/monthly-sales"
    },
    inventorySnapShot: {
      id: 27,
      isReport: 1,
      category: "INVENTORY",
      text: "Daily Inventory SnapShot",
      description: "This report lists the total inventory value and all the product’s details and their location.",
      link: "/report/inventorySnapShot"
    },
    employeeHours: {
      id: 28,
      isReport: 1,
      category: "EMPLOYEE",
      text: "Employee Total Hours",
      description: "This report displays each employee’s total hours worked for the dates selected.",
      link: "/report/employee-hours"
    },
    employeeTimesheet: {
      id: 29,
      isReport: 1,
      category: "EMPLOYEE",
      text: "Timesheet",
      description: "This report displays each employee’s time sheet, including their start, end and break times.",
      link: "/report/timesheet"
    },
    federalReport: {
      id: 30,
      isReport: 1,
      category: "EMPLOYEE",
      text: "FederalReport",
      year: { label: "Year", name: "Year" }
    },
    warehouseTransfer: {
      id: 31,
      isReport: 1,
      category: "INVENTORY",
      text: "Inventory Transfer",
      description: "This report lists all the products that have been transferred from one branch to another, and transfers within a branch.",
      link: "/report/warehouse-transfer"
    },
    discountReport: {
      id: 32,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Discount Report",
      description: "The Discount Report shows a summary of all the different types of discounts provided to your customers on the selected dates.",
      link: "/report/discount-report",
      orderTypeOptions: [
        { text: "All", value: "0" },
        { text: "In Store", value: "1" },
        { text: "Online", value: "2" }
      ],
      branchSummaryColumns: [
        { key: "BranchName", label: "Branch" },
        { key: "Manual", label: "Manual" },
        { key: "Customized", label: "Customized" },
        { key: "Campaign", label: "Campaign" },
        { key: "Loyalty", label: "Loyalty" }
      ],
      ManualColumns: [
        { key: "Date", label: "Date" },
        { key: "Branch", label: "Branch" },
        { key: "OrderId", label: "Order ID" },
        { key: "EmployeeName", label: "Employee" },
        { key: "OriginalPrice", label: "Original Price" },
        { key: "DiscountTotal", label: "Discount Total" },
        { key: "DiscountPercentage", label: "Discount %" },
        { key: "OrderType", label: "Order Type" },
        { key: "PriceMatch", label: "Price Match+" }
      ],
      CustomizedColumns: [
        { key: "Date", label: "Date" },
        { key: "Branch", label: "Branch" },
        { key: "OrderId", label: "Order ID" },
        { key: "CustomizedName", label: "Name" },
        { key: "EmployeeName", label: "Employee" },
        { key: "OriginalPrice", label: "Original Price" },
        { key: "DiscountTotal", label: "Discount Total" },
        { key: "DiscountPercentage", label: "Discount %" },
        { key: "OrderType", label: "Order Type" }
      ],
      CampaignColumns: [
        { key: "Date", label: "Date" },
        { key: "Branch", label: "Branch" },
        { key: "OrderId", label: "Order ID" },
        { key: "CampaignId", label: "Campaign ID" },
        { key: "CampaignName", label: "Name" },
        { key: "EmployeeName", label: "Employee" },
        { key: "OriginalPrice", label: "Original Price" },
        { key: "DiscountTotal", label: "Discount Total" },
        { key: "DiscountPercentage", label: "Discount %" },
        { key: "OrderType", label: "Order Type" }
      ],
      LoyaltyColumns: [
        { key: "Date", label: "Date" },
        { key: "Branch", label: "Branch" },
        { key: "OrderId", label: "Order ID" },
        { key: "EmployeeName", label: "Employee" },
        { key: "PatientId", label: "Member ID" },
        { key: "PatientName", label: "Member Name" },
        { key: "OriginalPrice", label: "Original Price" },
        { key: "DiscountTotal", label: "Discount Total" },
        { key: "DiscountPercentage", label: "Discount %" },
        { key: "PointsUsed", label: "Points used" }
      ]
    },
    dailySalesReport: {
      id: 33,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Sales Report Day over Day",
      description: "Sales Report Day over Day displays the gross sales, net sales, total tax, and discounts that occurred each day.",
      link: "/report/daily-sales-report"
    },

    monthlySalesReport: {
      id: 34,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Sales Report Month over Month",
      description: "Sales Report Month over Month displays the gross sales, net sales, total tax, and discounts that occurred each month.",
      link: "/report/monthly-sales-report"
    },
    yearlySalesReport: {
      id: 35,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Sales Report Year over Year",
      description: "Sales Report Year over Year displays the gross sales, net sales, gross profit, and net profits for the year selected.",
      link: "/report/yearly-sales-report"
    },
    sellThrough: {
      id: 36,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Sell Through Report",
      description: "The Sell Through Report displays each product and its detailed sell through data including the sold quantity, ordered quantity and the sell through percentage.",
      link: "/report/sell-through-report"
    }, dailyProfitReport: {
      id: 37,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Profit Report Day over Day",
      description: "Profit Report Day over Day displays the gross sales, net sales, gross profit, and net profits for the year selected.",
      link: "/report/daily-profit-report"
    }, monthlyProfitReport: {
      id: 38,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Profit Report Month over Month",
      description: "Profit Report Month over Month displays the gross sales, net sales, gross profit, and net profits for each month for the dates selected at the top.",
      link: "/report/monthly-profit-report"
    }, yearlyProfitReport: {
      id: 39,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Profit Report Year over Year",
      description: "Profit Report Year over Year displays the gross sales, net sales, gross profit, and net profits for each year thus far.",
      link: "/report/yearly-profit-report"
    }
    , gmroiReport: {
      id: 40,
      isReport: 1,
      category: "SALES REPORTS",
      text: "GMROI",
      description: "Gross Margin Return on Investment shows how much profit you have made on each dollar you invested in inventory.",
      link: "/report/gmroi-report"
    }
    , shoppingTrend: {
      id: 41,
      isReport: 1,
      removed: 1,
      category: "SALES REPORTS",
      text: "Shopping Trend",
      description: "The Shopping Trend report allows you to see the year’s trends in sales.",
      link: "/report/shopping-trend"
    }
    , aggregateSales: {
      id: 42,
      isReport: 1,
      removed: 1,
      category: "SALES REPORTS",
      text: "Aggregate Sales Report",
      description: "The Aggregate Sales Report visually presents the sales from all of the branches for each month of the year thus far.",
      link: "/report/aggregate-sales"
    }
    , aggregateInventory: {
      id: 43,
      isReport: 1,
      removed: 1,
      category: "SALES REPORTS",
      text: "Inventory & Sales",
      description: "This report visually presents the sales and inventory ebbs and flows for each day during the selected period.",
      link: "/report/aggregate-inventory"
    }
    , budgetPlannerReport: {
      id: 44,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Budget Planner",
      description: "After entering your current budget, the Budget Planner helps you to best allocate your funds for each category and individual products for maximum sales and profit.",
      link: "/report/budget-planner"
    }
    , aggregateBranches: {
      id: 45,
      isReport: 1,
      removed: 1,
      category: "SALES REPORTS",
      text: "Aggregate Branches",
      description: "Aggregate Branches report shows aggregated information from each branch.",
      link: "/report/aggregate-branches"
    }, combinedSalesReport: {
      id: 46,
      isReport: 1,
      removed: 1,
      category: "SALES REPORTS",
      text: "Combined Sales Report",
      description: "Aggregated information for each branch.",
      link: "/report/combined-sales"
    }, aggregateInventoryLevel: {
      id: 47,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Aggregate Inventory Level Report",
      description: "Aggregate Inventory Level Report shows Aggregated information for inventory.",
      link: "/report/aggregate-inventoryLevel"
    }, brandSales: {
      id: 48,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Sales By Brand",
      description: "Please specify a date range for sales.",
      link: "/report/brand-sales"
    }, onlineInstore: {
      id: 49,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Online Versus In-Store Sales",
      description: "Please specify a date range for sales. Filter by product name or leave blank for all sales.",
      link: "/report/onlineinstore-sales"
    }, orderList: {
      id: 50,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Order List By Online/In-store",
      description: "Order List By Online/In-store report shows the sales for in store or online.",
      link: "/report/orderlist-sales"
    }, inventoryAge: {
      id: 51,
      isReport: 1,
      category: "INVENTORY",
      text: "Inventory Age",
      description: "Please specify the product name, category name and brand name if needed",
      link: "/report/inventoryage"
    },
    membersDemographics: {
      id: 52,
      isReport: 1,
      category: "MEMBERS",
      text: "Member Demographics", /* Member Demographics */
      description: "This report shows the age and gender of members graphically.",
      link: "/report/members-demographics"
    },
    productRakingReport: {
      id: 53,
      isReport: 1,
      category: "CONSOLIDATED REPORTS",
      text: "Product Ranking Report", /* Product Ranking Report */
      description: "Product Ranking Report shows the rank of product, comparing the Base store with selected stores.",
      link: "/report/product-ranking"
    },
    restockbyCaps: {
      id: 54,
      isReport: 1,
      category: "INVENTORY",
      text: "Restock by Caps", /* Member Demographics */
      description: "This report shows all the products that inventory is equal to or smaller than the restock caps (caps greater than zero).",
      link: "/report/restockbycaps"
    },
    irccReport: {
      id: 55,
      isReport: 1,
      category: "CONSOLIDATED REPORTS",
      text: "IRCC Report", /* IRCC Report */
      description: "Independent Retail Cannabis Collective inventory and sale data report.",
      link: "/report/ircc"
    },
    productbycategory: {
      id: 56,
      isReport: 1,
      category: "INVENTORY",
      text: "Product by Category",
      description: "Product by Category shows the number of units and total cost by category.",
      link: "/report/category-product"
    },
    hourlySalesSecondary: {
      id: 57,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Hourly Sales Averaged",
      description: "Hourly Sales Averaged gives you averaged sales information for hours in a day.",
      link: "/report/hourly-sales-averaged",
      tableColumns: [
        { key: "Hour", label: "Hour", sortable: false },
        { key: "NetQuan", label: "Average Quantity", sortable: false },
        { key: "NetSale", label: "Average Gross Sales", sortable: false },
        { key: "Cost", label: "Average Cost", sortable: false },
        { key: "Profit", label: "Average Gross Profit", sortable: false },
        { key: "GP", label: "Average GP%", sortable: false }
      ]
    },
    productPriceChangeReport: {
      id: 58,
      isReport: 1,
      category: "INVENTORY",
      text: "Product Price Change",
      description: "This report shows the sales price changes over time, the difference in price, and the employee who made the change. Enter a product SKU to view price changes for that product.",
      link: "/report/product-price-change-report"
    },
    purchaseOrderReceiver: {
      id: 59,
      isReport: 1,
      category: "INVENTORY",
      text: "Purchase Order Receive / Unreceive Report",
      description: "This report shows the log for purchase order receives and unreceives.",
      link: "/report/purchase-order-receiver"
    },
    deliveryReport: {
      id: 60,
      isReport: 1,
      category: "EMPLOYEE",
      text: "Delivery",
      description: "This page shows all online orders for delivery for the chosen date.",
      link: "/report/delivery-report"
    },
    giftCardReport: {
      id: 61,
      isReport: 1,
      category: "INVENTORY",
      text: "Gift Card History",
      description: "This page shows the history for all gift card activities, including the date, balance, message, and employee.",
      link: "/report/gift-card-history"
    },
    MonthlyInventory: {
      id: 62,
      isReport: 1,
      category: "INVENTORY",
      text: "Monthly Inventory",
      description: "This page shows the monthly inventory summary including opening and closing inventory value, orders in, costs, and adjustments in and out.",
      year: { label: "Year", name: "Year" },
      link: "/report/MonthlyInventory"
    },
    InventoryMovement: {
      id: 63,
      isReport: 1,
      category: "INVENTORY",
      text: "Inventory Movement",
      description: "This page shows the detailed Inventory movement history for a specific product",
      link: "/report/inventory-movement"
    },
    InventoryLog: {
      id: 64,
      isReport: 1,
      category: "INVENTORY",
      text: "Inventory Log",
      description: "This page shows the Opening and Closing Inventory for each product.",
      link: "/report/inventory-log"
    },
    hourlySalesDateRange: {
      id: 65,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Hourly Sales by Date Range",
      description: "Hourly Sales by Range provides hourly data of units sold and sales for each day in the date range.",
      link: "/report/hourly-sales-date-range"
    },
    SalesSummaryDetails: {
      id: 100,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Sales Summary",
      description: "This page shows the sales summary in the desired date range, including tax information, cannabis/non-cannabis breakdown, and online/in-store breakdowns. Use the 'Details to Include' option to include desired information.",
      link: "/report/sales-summary-details"
    },
    AggregateBranchSalesInventory: {
      id: 101,
      isReport: 1,
      category: "SALES REPORTS",
      text: "Aggregate Sales & Inventory",
      description: "This page shows the sales summary and inventory value per branch.",
      link: "/report/aggregate-branch-sales-inventory"
    },
    AuditReport: {
      id: 102,
      isReport: 1,
      category: "INVENTORY",
      text: "Audit Report",
      description: "This report shows all completed audits in a consolidated export from Inventory Audit List",
      link: "/report/audit-report"
    },
    UncountedReport: {
      id: 103,
      isReport: 1,
      category: "INVENTORY",
      text: "Uncounted Report",
      description: "This report shows products that have not been counted in inventory audit in the past selected number of days.",
      link: "/report/uncounted-report"
    },
    FiskalyCashPointClosingReport: {
      id: 104,
      isReport: 1,
      category: "MANAGEMENT REPORTS",
      text: "Fiskaly Cash Point Closing Reports",
      description: "Downloading Cash Point Closing Export Files.",
      link: "/report/fiskaly-cash-point-closing-report"
    },
    HightideReports: {
      id: 201,
      isReport: 1,
      category: "MANAGEMENT REPORTS",
      text: "Management Reports",
      description: "",
      link: "/report/management-reports"
    }
  },
  mixAndMatch: {
    text: "Mix And Match",
    add: "Add New Mix And Match",
    edit: "Manage Mix And Match",
    controls: {
      addSettingButton: "Add",
      addMixAndMatch: "Add new Mix and Match",
      editButton: "Edit"
    },
    sameSettingError: "There is already a setting with the same quantity you selected, only one setting per quantity is allowed.",
    id: { label: "Id", hintText: "Id" },
    name: { label: "Name", hintText: "Name" },
    description: { label: "Description", hintText: "Description" },
    startDate: { label: "Start Date", hintText: "Start Date" },
    endDate: { label: "End Date", hintText: "End Date" },
    status: { label: "Status", hintText: "Status" },
    quantity: { label: "Quantity", hintText: "Quantity" },
    amount: { label: "Amount", hintText: "Amount" },
    type: { label: "Price Type", hintText: "Price Type" },
    settingsTableColumns: [
      { key: "Quantity", label: "Quantity" },
      { key: "TypeString", label: "Type" },
      { key: "Amount", label: "Amount" },
      { key: "Buttons", label: "" }
    ],
    itemsTableColumns: [
      { key: "Name", label: "Name" },
      { key: "Type", label: "Type" },
      { key: "Buttons", label: "" }
    ],
    listTableColumns: [
      { key: "Name", label: "Name" },
      { key: "Period", label: "Period" },
      { key: "Status", label: "Status" },
      { key: "Buttons", label: "" }
    ],
    messages: {
      createdMessage: "Mix and Match created successfully.",
      editedMessage: "Mix and Match edited successfully.",
      saveErrorMessage: "An error occurred when saving the Mix and Match's information, please try again. If the error persists, please contact the administrator."
    }
  },
  support: {
    landingPage: {
      title: "Support"
    },
    gettingStartedPage: {
      systemOverview: "System Overview",
      installation: "Installation",
      topic: "Topics",
      printer: "Printers Installation",
      scale: "Scale Installation",
      service: "Service Installation",
      features: "Major Features",
      gettingStarted: "Getting Started",
      measurementSetting: "Measurement Settings",
      priceMatrix: "Price Matrix",
      product: "Product",
      smartInventory: "Smart Inventory"
    },
    faq: {
      title: "FAQ",
      hardware: "Hardware",
      general: "General",
      product: "Product",
      user: "User",
      report: "Reports"
    },
    videoSupport: {
      title: "Video Support",
      pricing: {
        title: "Pricing",
        weightSetting: "Create & Modify Weight Settings",
        priceMatrix: "Add & Modify Price Matrix",
        campaigns: "Create & Modify Campaigns"
      },
      inventory: {
        title: "Inventory",
        warehouse: "Create Joints & Manage Warehouse",
        weightSetting: "Create & Modify Weight Settings",
        warehouse2: "Understand the Warehouse",
        product: "Create & Modify Products",
        poandvendor: "Create & Modify Purchase Orders and Vendors"
      },
      sales: {
        title: "Sales",
        sellProduct: "How to Sell Products"
      },
      users: {
        title: "Users",
        patient: "Create & Modify Members",
        doctor: "Create & Modify Doctors",
        poandvendor: "Create & Modify Purchase Orders and Vendors",
        clockinout: "Clock In & Out Shift"
      },
      admin: {
        title: "Admin",
        appSetting: "Modify App Settings"
      }
    },
    relatedVideoGroup: {
      title: "Related Video"
    },
    possales: {
      title: "POS Sales"
    },
    hardware: {
      title: "Hardware"
    },
    admin: {
      title: "Admin"
    }
  },
  DeliveryZone: {
    listTableColumns: [
      { key: "City", label: "Delivery Zone (City Name)" },
      { key: "Cost", label: "Delivery Fee" },
      { key: "Buttons", label: "" }
    ]
  },
  ecommerce: {
    name: "Ecommerce",
    listTableColumns: [
      { key: "Name", label: "Name" },
      { key: "Description", label: "Description" },
      { key: "Status", label: "Status" },
      { key: "EditIcons", label: "Edit" },
      { key: "DeleteIcons", label: "Delete" }
    ],
    WebmenuCategorylistTableColumns: [
      { key: "Name", label: "Name" },
      { key: "Description", label: "Description" },
      { key: "Status", label: "Status" },
      { key: "EditIcons", label: "Edit" }
    ],
    storeRulesColumns: [
      { key: "Name", label: "Name" },
      { key: "Status", label: "Status" },
      { key: "Buttons", label: "" },
      { key: "Delete", label: "" }
    ],
    menu: {
      messages: {
        createdMessage: "Menu created successfully.",
        editedMessage: "Menu edited successfully.",
        saveErrorMessage: "An error occurred when saving the Menu's information, please try again. If the error persists, please contact the administrator."
      },
      menuList: {
        title: "Web Menu",
        link: "/ecommerce/menu"
      },
      menuSave: {
        title: "Add New Menu",
        link: "/ecoomerce/menu/add",
        name: "Name",
        description: "Description",
        status: "Status",
        isMenu: "Display on Menu Page?",
        addedItemsTableColumns: [
          { key: "id", label: "ID" },
          { key: "name", label: "Name" },
          { key: "type", label: "Type" },
          { key: "icon", label: "" }
        ],
        addProductsTableColumns: [
          { key: "sku", label: "SKU" },
          { key: "name", label: "Name" },
          { key: "typeCategory", label: "Type and Category" },
          { key: "icon", label: "" }
        ],
        suggestedProductGroup: [
          { text: 'Flower', value: 1 },
          { text: 'Pre-Rolls', value: 2 },
          { text: 'Vaporizers', value: 3 },
          { text: 'Concentrates', value: 4 },
          { text: 'Edibles', value: 5 },
          { text: 'Topicals', value: 6 },
          { text: 'CBD', value: 7 },
          { text: 'Accessories', value: 8 },
          { text: 'Sativa', value: 9 },
          { text: 'Indica', value: 10 },
          { text: 'Hybrid', value: 11 },
          { text: 'Seeds', value: 12 },
          { text: 'Others', value: 13 },
          { text: 'Oils', value: 14 },
          { text: 'Capsules', value: 15 },
          { text: 'Beverages', value: 16 },
          { text: 'Extracts', value: 17 },
          { text: 'Infused Pre-Rolls', value: 18 }
        ]
      },
      menuEdit: {
        title: "Edit Menu"
      }
    },
    carousel: {
      messages: {
        createdMessage: "Carousel created successfully.",
        editedMessage: "Carousel edited successfully.",
        saveErrorMessage: "An error occurred when saving the Carousel's information, please try again. If the error persists, please contact the administrator."
      },
      carouselList: {
        title: "Carousel list",
        link: "/ecommerce/carousel"
      },
      carouselSave: {
        title: "Add New Carousel",
        link: "/ecoomerce/carousel/add",
        name: "Name",
        description: "Description",
        status: "Status",
        isMenu: "Display on Menu Page?",
        addedItemsTableColumns: [
          { key: "id", label: "ID" },
          { key: "name", label: "Name" },
          { key: "type", label: "Type" },
          { key: "icon", label: "" }
        ],
        addProductsTableColumns: [
          { key: "sku", label: "SKU" },
          { key: "name", label: "Name" },
          { key: "typeCategory", label: "Type and Category" },
          { key: "icon", label: "" }
        ]
      },
      carouselEdit: {
        title: "Edit Carousel"
      }
    },
    BannerList: {
        messages: {
          createdMessage: "BannerList created successfully.",
          editedMessage: "BannerList edited successfully.",
          saveErrorMessage: "An error occurred when saving the BannerList's information, please try again. If the error persists, please contact the administrator."
        },
        BannerListPage: {
          title: "Banner List",
          link: "/ecommerce/bannerList",
        },
        bannerManagementSave: {
          title: "Add New Banner",
          link: "/ecommerce/bannerList/add",
          name: "Name"
        },
        bannerManagementEdit: {
          title: "Edit Banner"
        }
    },
    storeRules: {
      messages: {
        createdMessage: "storeRules created successfully.",
        editedMessage: "storeRules edited successfully.",
        saveErrorMessage: "An error occurred when saving the storeRules's information, please try again. If the error persists, please contact the administrator."
      },
      storeRuleslList: {
        title: "Store Rules list",
        link: "/ecommerce/storerules"
      },
      storeRulesSave: {
        title: "Add New Store rules",
        link: "/ecoomerce/storeRules/add",
        name: "Name"
      },
      storeRulesEdit: {
        title: "Edit Store Rules"
      }
    },
    homeSetting: {
      title: "Carousel Order Setting",
      listTableColumnsAdd: [
        { key: "Name", label: "Name" },
        { key: "Description", label: "Description" },
        { key: "List", label: "List" }
      ],
      listTableColumnsOrder: [
        { key: "Name", label: "Name" },
        { key: "Description", label: "Description" },
        { key: "Order", label: "Order" }
      ],
      carouselSelect: {
        label: "Product group for Carousel"
      },
      messages: {
        savedMessage: "Home Setting saved successfully.",
        editedMessage: "Home Setting edited successfully.",
        saveErrorMessage: "An error occurred when saving the Home Setting's information, please try again. If the error persists, please contact the administrator."
      }
    },
    onlineOrders: {
      title: "Online Orders",
      listTableColumnsAdd: [
        { key: "OrderNumber", label: "Order #" },
        { key: "CreatedOn", label: "Created On" },
        { key: "Type", label: "Type" },
        { key: "Total", label: "Total" },
        { key: "Status", label: "Status" },
        { key: "Tips", label: "Tip Amount" },
        { key: "DeliveryFee", label: "Delivery Fee" },
        { key: "Options", label: "Options" }
      ],
      tableColumnsProducts: [
        { key: "product", label: "Product Name" },
        { key: "price", label: "Price" },
        { key: "quantity", label: "Quantity" },
        { key: "discount", label: "Discount" },
        { key: "total", label: "Total Price" }
      ],
      order: {
        messages: {
          savedMessage: "Online Order saved successfully.",
          // editedMessage: "Online Order edited successfully.",
          saveErrorMessage: "An error occurred when saving the Online Order's information, please try again. If the error persists, please contact the administrator."
        },
        orderList: {
          title: "Online Orders",
          link: "/ecommerce/online-orders"
        }
        // orderEdit: {
        //     title: "Edit Online Order"
        // }
      },
      orderStatusLabel: "Online Order Status",
      orderStatus: [
        { value: 0, text: "All" },
        { value: 1, text: "Created" },
        { value: 2, text: "Preparing" },
        { value: 3, text: "Ready" },
        { value: 4, text: "Completed" },
        { value: 6, text: "Cancelled" },
        { value: 7, text: "Sent to Fulfillment" }
      ],
      orderTypeLabel: "Online Order Type",
      orderType: [
        { value: 0, text: "All" },
        { value: 1, text: "Ecommerce" },
        { value: 2, text: "Express Checkout" },
        { value: 3, text: "Fulfillment" }
      ]
    }
  },
  //Source: http://www.calculconversion.com/sales-tax-calculator-hst-gst.html
  taxesByProvince: [
    {
      name: 'Alberta',
      province: 'AB',
      taxes: ['GST'],
      rate: 0,
      value: 1
    },
    {
      name: 'British Columbia',
      province: 'BC',
      taxes: ['GST', 'PST'],
      rate: 7,
      value: 2
    },
    {
      name: 'Manitoba',
      province: 'MB',
      taxes: ['GST', 'PST'],
      rate: 8,
      value: 5
    },
    {
      name: 'New-Brunswick',
      province: 'NB',
      taxes: ['HST'],
      rate: 10,
      value: 9
    },
    {
      name: 'Newfoundland and Labrador',
      province: 'NL',
      taxes: ['HST'],
      rate: 10,
      value: 4
    },
    {
      name: 'Northwest Territories',
      province: 'NT',
      taxes: ['GST'],
      rate: 0,
      value: 12
    },
    {
      name: 'Nova Scotia',
      province: 'NS',
      taxes: ['HST'],
      rate: 10,
      value: 7
    },
    {
      name: 'Nunavut',
      province: 'NU',
      taxes: ['GST'],
      rate: 0,
      value: 8
    },
    {
      name: 'Ontario',
      province: 'ON',
      taxes: ['HST'],
      rate: 8,
      value: 3
    },
    {
      name: 'Prince Edward Island',
      province: 'PE',
      taxes: ['HST'],
      rate: 10,
      value: 10
    },
    {
      name: 'Quebec',
      province: 'QC',
      taxes: ['GST', 'QST'],
      rate: 9.975,
      value: 11
    },
    {
      name: 'Saskatchewan',
      province: 'SK',
      taxes: ['GST', 'PST'],
      rate: 6,
      value: 6
    },
    {
      name: 'Yukon',
      province: 'YT',
      taxes: ['GST'],
      rate: 0,
      value: 13
    }
  ],
  federalReportType: {
    monthlySales: "monthlySales",
    federal: "federal"
  },
  userRole: {
    listTitle: "User Roles List",
    viewTitle: "User Role View",
    createdMessage: "Role created successfully.",
    editedMessage: "Role Saved successfully.",
    saveErrorMessage:
      "An error occurred when saving the User Role settings, please try again. If the error persists, please contact the administrator.",
    tableColumns: [
      { key: "Id", label: "#ID", visibleMode: "d-none", sortable: true },
      { key: "Role", label: "Role Name" },
      { key: "EditIcon", label: "Edit" }
    ],
    controls: {
      saveButton: "Save",
      editButton: "Edit",
      deleteButton: "Delete"
    }
  },
  BranchChartColors: [
    {
      branchid: 1,
      colorCode: "#8884d8"
    },
    {
      branchid: 2,
      colorCode: "#4ABA6C"
    },
    {
      branchid: 3,
      colorCode: "#FF4C5B"
    },
    {
      branchid: 4,
      colorCode: "#616165"
    },
    {
      branchid: 5,
      colorCode: "#9580EA"
    },
    {
      branchid: 6,
      colorCode: "#a5fc03"
    },
    {
      branchid: 7,
      colorCode: "#03fc56"
    },
    {
      branchid: 8,
      colorCode: "#03f4fc"
    },
    {
      branchid: 9,
      colorCode: "#fc0320"
    },
    {
      branchid: 10,
      colorCode: "#03fc56"
    }
  ],
  ProductInventoryByBranchType: {
    branchFrom: 1,
    branchTo: 2
  },
  StoreToDoor: {
    messages: {
      createdMessage: "StoreToDoor Created  successfully!",
      editedMessage: "StoreToDoor Updated  successfully!",
      deleteErrorMessage: "Error trying to delete storeToDoorLockDateAndTime",
      deleteMessage: "StoreToDoor Deleted  successfully!",
      editedErrorMessage: "Error updating storeToDoorLockDateAndTime. Ensure the data is changed as required and try again.",
      createdErrorMessage: "Error creating storeToDoorLockDateAndTime"
    }
  },
  PayStoneGiftCardOperationType: {
    Activation: 1,
    Reload: 2,
    Redeem: 3,
    Cancel: 4,
    Balance: 5
  },
  BirchmountGiftCardOperationType: {
    CheckBalance: 0,
    Activation: 1,
    EActivation: 2,
    Redeem: 3,
    Reload: 4,
    Reverse: 5,
    Refund: 6
  },
  POSfilterType: [
    { cannabisLabel: "All", vapeLabel: "All", value: 3 },
    { cannabisLabel: "Cannabis", vapeLabel: "Vape", value: 1 },
    { cannabisLabel: "Non-Cannabis", vapeLabel: "Accessories", value: 2 }
  ],
  POSfilterSpecies: [
    { label: "Indica", value: 1 },
    { label: "Hybrid", value: 2 },
    { label: "Sativa", value: 3 },
    { label: "Blend", value: 5 },
    { label: "Salted", value: 7 },
    { label: "Ice", value: 8 },
    { label: "Freebase", value: 9 },
    { label: "Pods", value: 10 },
    { label: "Disposables", value: 11 }

  ],
  POSWeightList: [
    { label: "0.5g", value: "0.5" },
    { label: "1g", value: "1" },
    { label: "3.5g", value: "3.5" },
    { label: "7g", value: "7" },
    { label: "14g", value: "14" },
    { label: "28g", value: "28" }
  ],
  AiVideoType: {
    All: "All",
    FirstNation: "FirstNation",
    LicensedRetail: "LicensedRetail"
  },
  banner: {
    controls: {
      saveButton: "Save",
      cancelButton: "Cancel"
    }
  }
};

export default LOOKUP;
